/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { IProps, IState, RuleMessage, TradeofResult } from './types';
import { Dispatch } from 'redux';
import { withRouter, Link } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage, setNestedObjectValues, FormikTouched } from 'formik';
import SliderMobile from 'components/SliderMobile';
import { DatePicker, Select } from 'formik-antd';
import _ from 'lodash';
import { EvalReq, Product, EvalRes, HeaderContent, FooterContent, BodyContent, BodyBaseContent } from 'bff/models/product';
import {
  SysOption as SysOptionModel,
  AmtOptContent,
  AmtOptContentChild,
  SysOptionReq,
  TravelWarning,
  TravelCountryContent
} from 'bff/models/info';
import { InsCount } from 'constants/enums/insCount.enum';
import InsuredPersonMatch from 'constants/models/insuredPersonMatch';
// import moment, { Moment } from 'moment';
import moment, { Moment } from 'moment-timezone';
import commonService from 'utils/commonService';
import apiCommonService from 'bff/services/commonService';
import service from 'bff/services/travelProductService';
import sweetAlertService from 'utils/sweetAlertService';
import { AgeOptAge } from 'constants/enums/amtOptAge.enum';
import { InsType } from 'constants/enums/insType.enum';
import { EvalInfoBodyType } from 'constants/enums/evalIfnoBodyType.enum';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import { AddFavoriteItem } from 'bff/models/member';
import { ExpanFooterContent, ExpanBodyContent, EvalExpans, ExpanBodyBaseContent } from 'constants/models/evalExpans';
import Fold from 'components/Fold';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { SysOptParamId } from 'constants/enums/sysOptParamId.enum';
import { ICalcFormValue } from 'constants/models/components/insurProcess/insureProcessCalc';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { TravelPlanType } from 'constants/enums/travelPlanType.enum';
import { RouterSettings } from 'constants/models/routerSettings';
import { InsureSubject } from 'constants/enums/insureSubject.enum';
import { CodeId } from 'constants/enums/codeId.enum';
import { RootReducersState } from 'redux/reducers';
import { connect } from 'react-redux';
import FormikFocusError from 'components/FormikFocusError';
import { IdInfoType } from 'constants/enums/idInfoType.enum';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { GeoAreaId } from 'constants/enums/geoAreaId.enum';
import { TravelSchengen } from 'constants/enums/travelSchengen.enum';
import { TravelWarningExpandData } from 'constants/models/components/insurProcess/insureProcessFill1st';
import { WarnStatus } from 'constants/enums/warnStatus.enum';
import { setAbroadModalVisibleAction, setConfirmModalVisibleAction, setExplainModalVisibleAction, setInsureHelperModalVisibleAction, setLoginModalVisible, setProductExplainModalVisibleAction } from 'redux/actions/modal.action';
import LoginModal from 'components/LoginModal';
import FilterSelect from 'components/FilterSelect';
import { ClockCircleOutlined } from '@ant-design/icons';
import { YesNoType } from 'constants/enums/yesNo.enum';
import InsureHelperModal from '../insureHelperModal';
import { InfoTraveloffQueryResp, TradeoffRule } from 'bff/models/info/infoTraveloffQuery';
import { TradeoffRange } from 'constants/enums/tradeoffRange.enum';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import ExplainModal from '../ExplainModal/ExplainModal';
import { Limit } from 'constants/enums/limit.enum';
import { ExplainModalTitleId } from 'constants/enums/explainModalTitleId.enum';
import AbroadModal from '../AbroadModal';
import ProductExplainModal from '../ProductExplainModal';
import ConfirmModal from '../ConfirmModal';

const initEvalInfo: EvalRes = {
  EVAL_RESULT: {
    INS_TYPE_ID: '',
    PROD_ID: '',
    HEADER: [[]],
    BODY: [],
    BODY_O15: [],
    BODY_U15: [],
    SUBTOTAL_O15: [[]],
    SUBTOTAL_U15: [[]],
    FOOTER: [[]]
  }
};

const initVal: ICalcFormValue = {
  INS_TYPE_ID: '',
  PROD_ID: '',
  SPI_ATTACHED: '',
  SPI_TYPE: '',
  START_DATE: '',
  START_HOUR: '',
  END_DATE: '',
  ONEORMORE: 1,
  INSURE_PERIOD: 0,
  INSURED_SUBJECT: '',
  OVER15: {
    PEOPLE: 0,
    LIFE_AMOUNT: 0,
    MFUNERAL: 0
  },
  UNDER15: {
    PEOPLE: 0,
    LIFE_AMOUNT: 0,
    MFUNERAL: 0
  },
  PROGRAM_ID: '',
  INS_COUNT: `${InsCount.One}`,
  OVER15_COUNT: '1',
  OVER15_AMOUNT: '',
  UNDER15_COUNT: '0',
  UNDER15_AMOUNT: '',
  MFUNERAL: 0,
  INSURED_TIME: null,
  TOURIST_DESTINATION: '',
  TOURIST_COUNTRY: '',
  TOURIST_SELECT: ''
};

const initState: IState = {
  prodId: '',
  insCountState: InsCount.One,
  insSubjectState: '',
  attachSpecState: true,
  attachSpecCheck: false,
  insSubjectSysOpts: new Array(0),
  insSubjectSysOptsFiltered: new Array(0),
  amtOpt: {
    INS_TYPE_ID: '',
    PROD_ID: '',
    AMOUNTOPTION: new Array(0),
    MFUNERALOPTION: new Array(0)
  },
  evalInfo: {
    EVAL_RESULT: {
      INS_TYPE_ID: '',
      PROD_ID: '',
      HEADER: [[]],
      BODY: new Array(0),
      BODY_O15: new Array(0),
      BODY_U15: new Array(0),
      SUBTOTAL_O15: [[]],
      SUBTOTAL_U15: [[]],
      FOOTER: [[]]
    }
  },
  evalExpanData: new Array(0),
  isResetForm: false,
  // pcDetailFoldsOpen: new Array(0),
  // mobileDetailFoldsOpen: new Array(0),
  openTimer: false,
  maxPeriod: 180,
  prodError: false,
  oneOrMoreSysOpts: new Array(0),
  spiSysOpts: new Array(0),
  travelSysOpts: new Array(0),
  blackoutSysOpts: new Array(0),
  travelPeriod: 0,
  insuredRange: null,
  insuredStartDate: null,
  insuredEndDate: null,
  tempTravels: new Array(0),
  activeTouristArea: '',
  travelWarnings: new Array(0),
  sysTime: 0,
  loginModalTitle: '',
  viewIndex: 0,
  deviceType: window.innerWidth < 813 ? 'mobile' : 'pc',
  programFixed: false,
  explainModalData: [],
  explainModalTitle: '',
  explainModalTitleOpts: [],
  policyAgeLimitOpts: [],
  insuredAgeLimitOpts: [],
  premIndex: null
};

let initialValues: ICalcFormValue = initVal;
/** 顯示特定活動 */
const showSpi = false;
let isTravelBubble = false;
const maxViewSize = 3;

class InsureProcessCalc extends React.Component<IProps, IState> {
    private formikRef: any = React.createRef();
    private calcResRef: any = React.createRef();
    private selectedPlanIdRef: any = React.createRef();
    private calcListMobileRef: any = React.createRef();
    private calcMobileHeaderRef: any = React.createRef();

    state = initState;

    checkWidth = () => {
      if (window.innerWidth < 813 && this.state.deviceType === 'pc') {
        this.handleOpenFold();
        this.setState(perv => ({
          ...perv,
          deviceType: 'mobile'
        }));
      };
      if (window.innerWidth > 812 && this.state.deviceType === 'mobile') {
        this.handleOpenFold();
        this.setState(perv => ({
          ...perv,
          deviceType: 'pc'
        }));
      }
    };

    componentDidMount = async () => {
      this.addWindowScrollEvent();
      // 取得系統時間
      const serverTimeMs = await apiCommonService.fetchSysTime();
      const sysTime = Math.ceil(serverTimeMs / 1000);
      const WPACodes = await apiCommonService.fetchCodeTables(CodeClass.WPA);

      const sysOptionReq: SysOptionReq = {
        PCLASS: [
          SysOptType.ONEORMORE,
          SysOptType.SPI,
          SysOptType.TRAVEL,
          'BLACKOUT',
          SysOptType.TRAVEL_PERIOD,
          SysOptType.TRAVEL_ELGPT,
          SysOptType.TRAVE_APTAGELMT,
          SysOptType.TRAVE_ISUAGELMT
        ]
      };

      const sysOptRes = await apiCommonService.fetchSysOpts(sysOptionReq);
      if (!sysOptRes) return;
      // 取得旅平險網要進件日與生效日間隔天數，查不到則維持 7 天
      const bgap = sysOptRes.TRAVEL_PERIOD.find(it => it.PARAM_ID === SysOptParamId.BGAP);
      const travelPeriod = bgap ? +bgap.PARAM_VALUE : 7;

      this.handleGetTravelAreaInfo(this.props.tempCalcFormVal?.PROD_ID || this.props.prodId, initialValues.INS_COUNT);
      this.handleSetTravelBubble();

      // 有暫存資料
      if (this.props.tempCalcFormVal) {
        initialValues = {
          ...initialValues,
          ...this.props.tempCalcFormVal,
          PROGRAM_ID: this.props.tempCalcFormVal.PROGRAM_ID ? this.props.tempCalcFormVal.PROGRAM_ID : this.props.programId
        };

        // 暫存的旅遊地區
        const country = this.props.tempCalcFormVal.TOURIST_COUNTRY;
        // 暫存的旅遊地點
        const destination = this.props.tempCalcFormVal.TOURIST_DESTINATION;
        initialValues = {
          ...initialValues,
          TOURIST_COUNTRY: country || initialValues.TOURIST_COUNTRY,
          TOURIST_DESTINATION: destination || initialValues.TOURIST_DESTINATION
        };

        // 登入狀態，且為一人投保，投保對象為自己，且低於 15 歲人數等於 1
        // 若是，清除試算結果，設定 低於 15 歲人數為 0，高於 15 歲人數為 1
        const isResetCalcRes = this.props.fetchFavoriteComplete &&
                this.props.tempCalcFormVal.INS_COUNT === InsCount.One &&
                this.props.tempCalcFormVal.INSURED_SUBJECT === InsureSubject.Self &&
                this.props.tempCalcFormVal.UNDER15_COUNT === '1';
        let evalInfo: EvalRes;
        let evalExpandData: EvalExpans[] = [];
        if (isResetCalcRes) {
          initialValues = {
            ...initialValues,
            UNDER15_COUNT: '0',
            OVER15_COUNT: '1'
          };
          evalInfo = initEvalInfo;
        } else {
          evalInfo = this.props.evalInfo;
          evalExpandData = this.props.evalExpanData;
        }

        // const insSubjectSysOpts = await service.fetchSubjectCode(this.props.tempCalcFormVal.INS_COUNT as InsCount) || new Array(0);
        // const PClass = commonService.getSubjectPClass(this.props.tempCalcFormVal.PROD_ID, this.props.tempCalcFormVal.INS_COUNT);
        // const insSubjectSysOpts = (PClass && await service.fetchSubjectCode(PClass)) || new Array(0);

        const amtOptResult = await service.fetchAmtOpt(this.props.insTypeId as InsType, this.props.tempCalcFormVal.PROD_ID);
        if (amtOptResult) {
          this.setState({
            amtOpt: amtOptResult
          });
        };

        this.handleSetMaxPeriod(this.props.tempCalcFormVal.PROD_ID);

        const tempTravels = this.props.tempTravels ? [...this.props.tempTravels] : [];
        const activeTouristArea = this.props.activeTouristArea;
        this.setState((prevState) => ({
          prodId: this.props.tempCalcFormVal.PROD_ID,
          insuredStartDate: this.props.tempCalcFormVal.START_DATE,
          insuredEndDate: this.props.tempCalcFormVal.END_DATE,
          insCountState: this.props.tempCalcFormVal.INS_COUNT,
          insSubjectState: this.props.tempCalcFormVal.INSURED_SUBJECT,
          isResetForm: true,
          evalInfo: evalInfo,
          evalExpanData: evalExpandData,
          attachSpecState: this.validAttachState(this.props.tempCalcFormVal.PROD_ID),
          attachSpecCheck: Boolean(this.props.tempCalcFormVal.SPI_ATTACHED),
          oneOrMoreSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptRes[SysOptType.ONEORMORE])),
          spiSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptRes[SysOptType.SPI])),
          travelSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptRes[SysOptType.TRAVEL])),
          blackoutSysOpts: sysOptRes.BLACKOUT,
          travelPeriod,
          activeTouristArea: activeTouristArea || prevState.activeTouristArea,
          tempTravels: tempTravels.length > 0 ? [...tempTravels] : [...prevState.tempTravels],
          sysTime,
          explainModalData: this.props.explainModalData,
          explainModalTitleOpts: this.props.explainModalTitleOpts,
          policyAgeLimitOpts: this.props.policyAgeLimitOpts,
          insuredAgeLimitOpts: this.props.insuredAgeLimitOpts,
          premIndex: evalInfo.EVAL_RESULT.HEADER[0].findIndex(item => item.PLAN_ID === 'XP') - 1
        }));
        this.handleSubjectOpts(this.props.tempCalcFormVal.PROD_ID, this.props.tempCalcFormVal.INS_COUNT, moment(initialValues.START_DATE, 'YYYYMMDD'), sysTime, travelPeriod);

        return;
      }

      initialValues = {
        ...initialValues,
        INS_TYPE_ID: this.props.insTypeId,
        PROD_ID: this.props.prodId,
        PROGRAM_ID: this.props.programId
      };

      // const insSubjectSysOpts = await service.fetchSubjectCode(InsCount.One) || new Array(0);
      // const PClass = commonService.getSubjectPClass(initialValues.PROD_ID, initialValues.INS_COUNT);
      // const insSubjectSysOpts = (PClass && await service.fetchSubjectCode(PClass)) || new Array(0);

      const amtOptResult = await service.fetchAmtOpt(this.props.insTypeId as InsType, this.props.prodId || 'NTD');
      if (amtOptResult) {
        _.forEach(amtOptResult.AMOUNTOPTION, (amtOpt: AmtOptContent) => {
          switch (amtOpt.UNDER15) {
            case AgeOptAge.OverFifteen:
              initialValues = {
                ...initialValues,
                OVER15_AMOUNT: amtOpt.DEFAULT_OPTION[0].VALUE
              };
              break;
            case AgeOptAge.UnderFifteen:
              initialValues = {
                ...initialValues,
                UNDER15_AMOUNT: amtOpt.DEFAULT_OPTION[0].VALUE
              };
              break;
          }
        });

        // 投保對象15歲以下，喪葬費用採用「選項第一筆」作為預設值（若無選項則為 0）
        initialValues = {
          ...initialValues,
          MFUNERAL: +amtOptResult.MFUNERALOPTION
            .filter(opt => opt.UNDER15 === '1')[0]
                    ?.DEFAULT_OPTION[0]?.VALUE ?? 0
        };

        this.setState({
          amtOpt: amtOptResult
        });
      }

      this.handleSetMaxPeriod(this.props.prodId);

      this.setState({
        prodId: this.props.prodId,
        attachSpecState: this.validAttachState(this.props.prodId),
        oneOrMoreSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptRes[SysOptType.ONEORMORE])),
        spiSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptRes[SysOptType.SPI])),
        travelSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(sysOptRes[SysOptType.TRAVEL])),
        blackoutSysOpts: sysOptRes.BLACKOUT,
        travelPeriod,
        WPACodes,
        sysTime,
        explainModalTitleOpts: sysOptRes.TRAVEL_ELGPT,
        policyAgeLimitOpts: sysOptRes.TRAVE_APTAGELMT,
        insuredAgeLimitOpts: sysOptRes.TRAVE_ISUAGELMT
        // explainModalTitleOpts: [
        //   {
        //     PARAM_ID: 'NTA',
        //     PARAM_ORDER: 1,
        //     PARAM_TEXT: '國內、國外旅遊適用',
        //     PARAM_VALUE: '1',
        //     SN: 0,
        //     PCLASS: '',
        //     NOTE: ''
        //   },
        //   {
        //     PARAM_ID: 'NTAG_ONE',
        //     PARAM_ORDER: 2,
        //     PARAM_TEXT: '申根旅遊一人投保適用',
        //     PARAM_VALUE: '2',
        //     SN: 0,
        //     PCLASS: '',
        //     NOTE: ''
        //   },
        //   {
        //     PARAM_ID: 'NTAG_MORE',
        //     PARAM_ORDER: 3,
        //     PARAM_TEXT: '申根旅遊多人投保適用',
        //     PARAM_VALUE: '3',
        //     SN: 0,
        //     PCLASS: '',
        //     NOTE: ''
        //   }
        // ],
        // policyAgeLimitOpts: [
        //   {
        //     PARAM_ID: 'NTAG',
        //     PARAM_ORDER: 1,
        //     PARAM_TEXT: '申根旅遊要保人年齡限制 ',
        //     PARAM_VALUE: '18',
        //     SN: 0,
        //     PCLASS: '',
        //     NOTE: ''
        //   },
        //   {
        //     PARAM_ID: 'NTA',
        //     PARAM_ORDER: 1,
        //     PARAM_TEXT: '國外旅遊要保人年齡限制 ',
        //     PARAM_VALUE: '18',
        //     SN: 0,
        //     PCLASS: '',
        //     NOTE: ''
        //   },
        //   {
        //     PARAM_ID: 'NTD',
        //     PARAM_ORDER: 1,
        //     PARAM_TEXT: '國內旅遊要保人年齡限制 ',
        //     PARAM_VALUE: '18',
        //     SN: 0,
        //     PCLASS: '',
        //     NOTE: ''
        //   }
        // ],
        // insuredAgeLimitOpts: [
        //   {
        //     PARAM_ID: 'NTAG',
        //     PARAM_ORDER: 1,
        //     PARAM_TEXT: '申根旅遊被保險人年齡限制 ',
        //     PARAM_VALUE: '15',
        //     SN: 0,
        //     PCLASS: '',
        //     NOTE: ''
        //   },
        //   {
        //     PARAM_ID: 'NTA',
        //     PARAM_ORDER: 1,
        //     PARAM_TEXT: '國外旅遊被保險人年齡限制 ',
        //     PARAM_VALUE: '7',
        //     SN: 0,
        //     PCLASS: '',
        //     NOTE: ''
        //   },
        //   {
        //     PARAM_ID: 'NTD',
        //     PARAM_ORDER: 1,
        //     PARAM_TEXT: '國內旅遊被保險人年齡限制 ',
        //     PARAM_VALUE: '7',
        //     SN: 0,
        //     PCLASS: '',
        //     NOTE: ''
        //   }
        // ]
      });
      this.handleExplainModalData(initialValues.PROD_ID, initialValues.INS_COUNT);
      this.handleSubjectOpts(initialValues.PROD_ID, initialValues.INS_COUNT);
      window.addEventListener('resize', this.checkWidth);
    }

    componentWillUnmount = () => {
      this.removeWindowScrollEvent();
      // 追加勾選的地區國家於試算的上行電文
      const destinationId: string[] = [];
      this.state.tempTravels.forEach(it => {
        if (it && it.COUNTRY_ID) destinationId.push(it.COUNTRY_ID);
      });
      const formVal = this.formikRef.current.values;
      const evalReq: EvalReq = this.handleGetEvalReq(formVal, destinationId);
      this.props.onUnmount(
        formVal,
        evalReq,
        this.state.evalInfo,
        this.state.evalExpanData,
        this.state.travelSysOpts,
        this.state.activeTouristArea,
        this.state.tempTravels,
        this.state.explainModalData,
        this.state.explainModalTitleOpts,
        this.state.policyAgeLimitOpts,
        this.state.insuredAgeLimitOpts
      );

      initialValues = {
        ...initVal
      };
      window.removeEventListener('resize', this.checkWidth);
    }

    componentDidUpdate (prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
      if (this.state.evalInfo !== prevState.evalInfo) {
        this.handleOpenFold();
      }
    }

    getLimitID = (prodId: string, insCount: string) => {
      if (!prodId || !insCount) return;
      if (prodId === TravelPlanType.Abroad || prodId === TravelPlanType.Domestic) {
        return Limit.NTDO;
      }
      if (prodId === TravelPlanType.NTAG && (insCount === InsCount.One || insCount === InsCount.MORE)) {
        return Limit.NTAGO;
      }
    }

    handleExplainModalData = async (prodId: string, insCount: string) => {
      const limitID = this.getLimitID(prodId, insCount) || Limit.NTAO;
      const explainModalData = limitID ? await service.fetchExplainModalData(InsType.Travel, limitID) : [];
      const explainModalTitle = limitID ? this.getModalTitle(limitID).PARAM_TEXT : '';

      this.setState(prev => ({
        ...prev,
        explainModalData,
        explainModalTitle
      }));
    }

    getModalTitle = (id: Limit) => {
      if (id === Limit.NTAGO || id === Limit.NTAGM) {
        return this.state.explainModalTitleOpts.filter(opt => opt.PARAM_ID === ExplainModalTitleId.NTAG)[0];
      } else {
        return this.state.explainModalTitleOpts.filter(opt => opt.PARAM_ID === ExplainModalTitleId.NTA)[0];
      }
    }

    handleSubjectOpts = async (prodId: string, insCount: string, startDate?: Moment, sysTime?: number | null, travelPeriod?: any) => {
      if (!prodId || !insCount) return;

      const PClass = commonService.getSubjectPClass(prodId, insCount);
      const insSubjectSysOpts = (PClass && await service.fetchSubjectCode(PClass)) || new Array(0);

      if (startDate && travelPeriod) {
        let sysOptsFiltered: any;
        if (sysTime === null) {
          const serverTimeMs = await apiCommonService.fetchSysTime();
          const sysTime = Math.ceil(serverTimeMs / 1000);
          sysOptsFiltered = this.handleFilterInsuredSubjectOpts(insSubjectSysOpts, startDate, sysTime, travelPeriod);
        } else if (sysTime) {
          sysOptsFiltered = this.handleFilterInsuredSubjectOpts(insSubjectSysOpts, startDate, sysTime, travelPeriod);
        }

        this.setState(prev => ({
          ...prev,
          insSubjectSysOpts: insSubjectSysOpts,
          insSubjectSysOptsFiltered: sysOptsFiltered
        }));

        if (sysOptsFiltered.length === 1) this.formikRef.current.setFieldValue('INSURED_SUBJECT', sysOptsFiltered[0].PARAM_VALUE);
        return;
      }

      this.setState(prev => ({
        ...prev,
        insSubjectSysOpts: insSubjectSysOpts
      }));
    }

    handleOpenFold = () => {
      const over15Length = this.state.evalInfo.EVAL_RESULT.BODY_O15.length;
      const under15Length = this.state.evalInfo.EVAL_RESULT.BODY_U15.length;
      const itemLength = this.state.evalExpanData.length;
      const length = over15Length > under15Length ? over15Length : under15Length;
      this.setState(prev => ({
        ...prev,
        pcDetailFoldsOpen: Array(length).fill(true),
        mobileDetailFoldsOpen: Array(itemLength).fill(Array(length).fill(true))
      }));
    }

    /**
     * @description 取得攤平後的旅遊地區資訊
     */
    handleGetTravelAreaInfo = (prodId: string, insCount: string) => {
      const travelWarningArray: TravelWarningExpandData[] = new Array(0);
      const tempTravels: TravelWarningExpandData[] = new Array(0);
      let activeTouristArea = '';

      if (this.props.travelWarnings && this.props.travelWarnings.length > 0) {
        const isDomestic = prodId === TravelPlanType.Domestic || prodId === TravelPlanType.MPA || prodId === TravelPlanType.WPA;

        _.forEach(this.props.travelWarnings, (travelWarning: TravelWarning, index: number) => {
          _.forEach(travelWarning.COUNTRYS, (countrys: TravelCountryContent, index: number) => {
            const travelInfo: TravelWarningExpandData = {
              GEOAREA_ID: travelWarning.GEOAREA_ID,
              GEOAREA_NAME: travelWarning.GEOAREA_NAME,
              COUNTRY_ID: countrys.COUNTRY_ID,
              COUNTRY_NAME: countrys.COUNTRY_NAME,
              HOT_COUNTRY: countrys.HOT_COUNTRY,
              SCHENGEN: countrys.SCHENGEN,
              WARN_STATUS: countrys.WARN_STATUS,
              WARN_MSG: countrys.WARN_MSG
            };

            travelWarningArray.push(travelInfo);

            if (isDomestic && travelWarning.GEOAREA_ID === GeoAreaId.Domestic) {
              // 提示警示訊息
              this.handleShwoTravelMsg(travelInfo);

              if (travelInfo.WARN_STATUS === WarnStatus.Orange) {
                apiCommonService.fetchSysTime().then((res: any) => {
                  travelInfo.WARN_SELECT_TIME = res;
                });
              }

              tempTravels.push(travelInfo);

              initialValues = {
                ...initialValues,
                PROD_ID: prodId,
                START_DATE: '',
                END_DATE: '',
                INSURED_TIME: '',
                START_HOUR: '',
                TOURIST_DESTINATION: travelInfo.GEOAREA_ID || '',
                TOURIST_COUNTRY: travelInfo.COUNTRY_ID || '',
                INS_COUNT: insCount
              };

              activeTouristArea = travelInfo.GEOAREA_ID || '';
            }
          });
        });
      }

      // initialValues = {
      //   ...initialValues,
      //   START_DATE: '',
      //   END_DATE: '',
      //   INSURED_TIME: ''
      // };

      this.setState(prevState => {
        return {
          ...prevState,
          // 變換種類時保留日期
          // insuredStartDate: '',
          // insuredEndDate: '',
          travelWarnings: [...travelWarningArray],
          tempTravels: [...tempTravels],
          activeTouristArea: activeTouristArea
        };
      });
    }

    /**
     * @description 設定旅遊泡泡資訊
     */
    handleSetTravelBubble = () => {
      isTravelBubble = false;

      // const { planData } = this.props.tempCalc;

      // if (!planData) return;

      // const { PROD_ID } = planData;
      const prodId = this.formikRef.current.values.PROD_ID;
      if (!prodId || prodId !== TravelPlanType.TBP) return;

      const travelInfo = _.find(this.state.travelWarnings, (travelInfo: TravelWarningExpandData) => travelInfo.GEOAREA_ID === GeoAreaId.AZ && travelInfo.COUNTRY_ID === 'PW');

      if (!travelInfo) return;

      // 提示警示訊息
      this.handleShwoTravelMsg(travelInfo);

      if (travelInfo.WARN_STATUS === WarnStatus.Orange) {
        apiCommonService.fetchSysTime().then((res: any) => {
          travelInfo.WARN_SELECT_TIME = res;
        });
      }

      isTravelBubble = true;

      // initialValues = {
      //   ...initialValues as IFill1stFormValue,
      //   TOURIST_DESTINATION: travelInfo.GEOAREA_ID || '',
      //   TOURIST_COUNTRY: travelInfo.COUNTRY_ID || ''
      // };

      const tempTravels: TravelWarningExpandData[] = new Array(0);
      tempTravels.push(travelInfo);

      this.setState(prevState => {
        return {
          ...prevState,
          tempTravels: tempTravels,
          activeTouristArea: travelInfo.GEOAREA_ID || ''
        };
      });
    }

    /**
     * @description 判斷 附加特定活動保險 是否可以勾選
    */
    validAttachState = (prodId: string) => {
      // 旅遊種類為國內旅遊、國外旅遊、申根保險，才可勾選
      if (this.props.products && this.props.products.SPI_ATTACH.length > 0) {
        return this.props.products.SPI_ATTACH.indexOf(prodId) === -1;
      }

      return true;
    };

    /**
     * @description 取得選取種類投保天數
    */
    handleSetMaxPeriod = (prodId: string) => {
      const prod = _.find(this.props.products.PRODUCT, (prod: Product, index: number) => prod.PROD_ID === prodId);
      if (prod && prod.MAX_PERIOD) {
        this.setState(prevState => {
          return {
            ...prevState,
            maxPeriod: prod.MAX_PERIOD
          };
        });
      }
    };

    /**
     * @description 產生 PC 保費試算結果，開啟/關閉詳細資訊，Fold 組件開啟關閉狀態的 Array
     */
    handleUpdatePcDetailFoldsOpen = (evalInfo: any) => {
      if (!evalInfo) return;

      const pcDetailFoldArr = _.map(evalInfo.EVAL_RESULT.BODY, (item: BodyContent) => _.has(item, 'BODY') ? false : null);

      this.setState(prevState => {
        return {
          ...prevState,
          pcDetailFoldsOpen: pcDetailFoldArr
        };
      });
    }

    /**
     * @description 產生 Mobile 保費試算結果，開啟/關閉詳細資訊，Fold 組件開啟關閉狀態的 Array
     */
    handleUpdateMobileDetailFoldsOpen = (evalExpanData: any) => {
      if (!evalExpanData || evalExpanData.length <= 0) return;

      const mobileDetailFoldArr = _.map(evalExpanData, (mobileEval: EvalExpans) => (
        // 判斷資料有 'BODY' 這個 Key，代表有詳細資訊的資料，預設為 False (Fold 關閉)
        _.map(mobileEval.BODY, (mobileEvalBody: ExpanBodyContent) => _.has(mobileEvalBody, 'BODY') ? false : null)
      ));

      this.setState(prevState => {
        return {
          ...prevState,
          mobileDetailFoldsOpen: mobileDetailFoldArr
        };
      });
    }

    /**
     * @description 取得保費試算用 Request Model
    */
    handleGetEvalReq = (values: ICalcFormValue, destinationId: string[]) => {
      const startDate = moment(values.START_DATE).format('YYYY-MM-DD 00:00:00');
      const endDate = moment(values.END_DATE).format('YYYY-MM-DD 00:00:00');
      const period = moment(endDate).diff(moment(startDate), 'd');
      const evalReq: EvalReq = {
        ...values,
        SPI_ATTACHED: values.SPI_ATTACHED ? '1' : '0',
        START_DATE: moment(values.START_DATE).format('YYYYMMDD'),
        START_HOUR: moment(values.INSURED_TIME).isValid()
          ? moment(values.INSURED_TIME).format('HH')
          : '',
        END_DATE: moment(values.END_DATE).format('YYYYMMDD'),
        INSURE_PERIOD: period,
        OVER15: {
          PEOPLE: +values.OVER15_COUNT > 0 ? +values.OVER15_COUNT : 0,
          LIFE_AMOUNT: +values.OVER15_AMOUNT,
          MFUNERAL: 0
        },
        UNDER15: {
          PEOPLE: +values.UNDER15_COUNT > 0 ? +values.UNDER15_COUNT : 0,
          LIFE_AMOUNT: +values.UNDER15_AMOUNT,
          MFUNERAL: +values.MFUNERAL
        },
        DESTINATION_ID: destinationId
      };

      return evalReq;
    };

    /**
     * @description 處理「投保對象15歲以上人數」Field Change 執行的事件
     * @param event Event Object
     */
    handleOver15CountFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const fieldValue = event.target.value;
      if (this.formikRef.current.values.INS_COUNT === InsCount.One) {
        this.formikRef.current.setFieldValue('UNDER15_COUNT', fieldValue === '0' ? '1' : '0');
      }
      this.formikRef.current.handleChange('OVER15_COUNT')(event);
    };

    /**
     * @description 處理「投保對象未滿15歲人數」Field Change 執行的事件
     * @param event Event Object
     */
    handleUnder15CountFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const fieldValue = event.target.value;
      if (this.formikRef.current.values.INS_COUNT === InsCount.One) {
        this.formikRef.current.setFieldValue('OVER15_COUNT', fieldValue === '0' ? '1' : '0');
      }
      this.formikRef.current.handleChange('UNDER15_COUNT')(event);
    };

    /**
     * @description 選取旅遊地區，新增旅遊標籤資料
    */
    handleSetTravelTag = async (countryId: string) => {
      const travelInfo = _.find(this.state.travelWarnings, (travel: TravelWarningExpandData) => travel.COUNTRY_ID === countryId);

      // 已新增過的就不再新增
      let canUpdate = travelInfo && _.every(this.state.tempTravels, (travel: TravelWarningExpandData) => travel.COUNTRY_ID !== travelInfo.COUNTRY_ID);

      // 判斷是否已達 6 個
      canUpdate = canUpdate && this.state.tempTravels.length < 6;

      if (canUpdate && travelInfo) {
        // 提示警示訊息
        this.handleShwoTravelMsg(travelInfo);

        // 判斷旅遊警示是否為橙色，是，紀錄選取時間
        let warnSelectTime;
        if (travelInfo.WARN_STATUS === WarnStatus.Orange) {
          warnSelectTime = await apiCommonService.fetchSysTime();
        };

        travelInfo.WARN_SELECT_TIME = warnSelectTime;
        this.handleAddTempTravels(travelInfo);
      }
    }

    /**
     * @description 顯示選取得旅遊地區警示資訊
    */
    handleShwoTravelMsg = (travelInfo: TravelWarningExpandData) => {
      // 同時為橘色警戒國家、且有提示訊息
      if (travelInfo.WARN_STATUS === WarnStatus.Orange && travelInfo.WARN_MSG) {
        sweetAlertService.modal({
          html: '您選擇之旅遊地點為橘色警示國家，請確認'
        }).then(() => {
          sweetAlertService.modal({
            html: travelInfo.WARN_MSG
          });
        });

        return;
      }

      // 為橘色警戒國家
      if (travelInfo.WARN_STATUS === WarnStatus.Orange) {
        sweetAlertService.modal({
          html: '您選擇之旅遊地點為橘色警示國家，請確認'
        });
      }

      // 為有提示訊息
      if (travelInfo.WARN_MSG) {
        sweetAlertService.modal({
          html: travelInfo.WARN_MSG
        });
      }
    }

    /**
     * @description 新增選取的旅遊地點資訊，並移除錯誤訊息
    */
    handleAddTempTravels = (travelInfo: TravelWarningExpandData) => {
      const tempTravels = [...this.state.tempTravels];
      tempTravels.push(travelInfo);

      if (tempTravels.length > 0) {
        this.formikRef.current.setFieldError('TOURIST_DESTINATION', '');
        this.formikRef.current.setFieldError('TOURIST_COUNTRY', '');
      }

      this.setState({
        tempTravels: [...tempTravels],
        evalInfo: initEvalInfo,
        evalExpanData: new Array(0)
      });
    }

    /**
     * @description 移除旅遊標籤
     * @param areaId 地區 Id
     * @param countryId 城市 Id
     */
    handleRemoveTravelTag = (areaId: string, countryId: string) => {
      if (isTravelBubble) return;

      const removeIndex = _.findIndex(this.state.tempTravels, (travel: TravelWarningExpandData) =>
        travel.GEOAREA_ID === areaId && travel.COUNTRY_ID === countryId);

      const updateTempTravels = [...this.state.tempTravels];

      updateTempTravels.splice(removeIndex, 1);
      let activeTouristArea = this.state.activeTouristArea;
      if (updateTempTravels.length === 0) {
        this.formikRef.current.setFieldValue('TOURIST_DESTINATION', '');
        this.formikRef.current.setFieldValue('TOURIST_COUNTRY', '');
        activeTouristArea = '';
      }

      this.setState({
        tempTravels: [...updateTempTravels],
        activeTouristArea: activeTouristArea,
        evalInfo: initEvalInfo,
        evalExpanData: new Array(0)
      });
    }

    /**
     * @description 保費試算-我要保這個事件
     * @param planId 計畫代碼
     */
    handleInsured = (planId: string) => {
      const memberId = storageService.getItem(storageKeys.MemberId);
      const isLogined = !!memberId;
      if (isLogined) {
        this.handleExecuteInsured(planId);
      } else {
        apiCommonService.fetchSysTime().then((serverTimeMs) => {
          const sysTime = Math.ceil(serverTimeMs / 1000);
          this.handleSetLoginModalTitle(sysTime).then(() => {
            this.selectedPlanIdRef.current = planId;
            this.props.setLoginModalVisible(true);
          });
        });
      }
      // const evalReq: EvalReq = this.handleGetEvalReq(this.formikRef.current.values);
      // const planData = _.find(this.state.evalExpanData, (evalInfoData: EvalExpans) => evalInfoData.HEADER.PLAN_ID === planId);
      // this.props.onInsured(this.formikRef.current.values, evalReq, this.state.evalInfo, this.state.evalExpanData, planData, this.state.maxPeriod, this.state.travelSysOpts, this.state.activeTouristArea, this.state.tempTravels);
    };

    /**
     * @description 保費試算-我要保這個事件 (透過登入跳窗)
     */
    handleInsuredByLoginModal = () => {
      const planId = this.selectedPlanIdRef.current;
      this.props.setLoginModalVisible(false);
      this.handleExecuteInsured(planId);
      this.setState(prevState => {
        return {
          ...prevState,
          loginModalTitle: ''
        };
      });
    };

    /**
     * @description 執行保費試算-我要保這個事件
     * @param planId 計畫代碼
     */
    handleExecuteInsured = (planId: string) => {
      // 追加勾選的地區國家於試算的上行電文
      const destinationId: string[] = [];
      this.state.tempTravels.forEach(it => {
        if (it && it.COUNTRY_ID) destinationId.push(it.COUNTRY_ID);
      });
      const evalReq: EvalReq = this.handleGetEvalReq(this.formikRef.current.values, destinationId);
      const planData = _.find(this.state.evalExpanData, (evalInfoData: EvalExpans) => evalInfoData.HEADER.PLAN_ID === planId);
      this.props.onInsured(this.formikRef.current.values, evalReq, this.state.evalInfo, this.state.evalExpanData, planData,
        this.state.maxPeriod, this.state.travelSysOpts, this.state.activeTouristArea, this.state.tempTravels,
        this.state.explainModalData, this.state.explainModalTitleOpts, this.state.policyAgeLimitOpts, this.state.insuredAgeLimitOpts);
    };

    handleSetLoginModalTitle = async (sysTimeSec: number) => {
      if (!sysTimeSec || !this.formikRef.current.values.START_DATE) return;
      const formValues = this.formikRef.current.values;
      const sysDate = moment.unix(sysTimeSec).startOf('day');
      const startDate = moment(this.formikRef.current.values.START_DATE).startOf('day');
      const effectiveDays = startDate.diff(sysDate, 'days');
      if (effectiveDays < this.state.travelPeriod) {
        if (
          (formValues.INS_COUNT === InsCount.One && formValues.INSURED_SUBJECT === InsureSubject.Self) ||
          (formValues.INS_COUNT === InsCount.MORE && formValues.INSURED_SUBJECT === InsureSubject.Self)
        ) {
          // return commonService.getCodeMsg(this.props.UICode, CodeId.U049);
          // 替換 ${n} 字串為「旅平險網要進件日與生效日間隔天數」數值 (系統參數)
          const rawMsg = commonService.getCodeMsg(this.props.UICode, CodeId.U049);
          const snippets = rawMsg.split(/\$\{n\}/);
          this.setState(prevState => {
            return {
              ...prevState,
              loginModalTitle: snippets.length > 1 ? `${snippets[0]}${this.state.travelPeriod}${snippets[1]}` : rawMsg
            };
          });
        }
      } else if (effectiveDays >= this.state.travelPeriod) {
        if (
          (formValues.INS_COUNT === InsCount.One && formValues.INSURED_SUBJECT === InsureSubject.Self) ||
          (formValues.INS_COUNT === InsCount.MORE && formValues.INSURED_SUBJECT === InsureSubject.Self)
        ) {
          // return commonService.getCodeMsg(this.props.UICode, CodeId.U050);
          this.setState(prevState => {
            return {
              ...prevState,
              loginModalTitle: commonService.getCodeMsg(this.props.UICode, CodeId.U050)
            };
          });
        }
        if (
          (formValues.INS_COUNT === InsCount.One && formValues.INSURED_SUBJECT === InsureSubject.Relatives) ||
          (formValues.INS_COUNT === InsCount.MORE && formValues.INSURED_SUBJECT === InsureSubject.All)
        ) {
          // return commonService.getCodeMsg(this.props.UICode, CodeId.U051);
          this.setState(prevState => {
            return {
              ...prevState,
              loginModalTitle: commonService.getCodeMsg(this.props.UICode, CodeId.U051)
            };
          });
        }
      }
    };

    handleLoginModalnLoginDone = () => {
      this.handleInsuredByLoginModal();
    };

    handleLoginModalClose = () => {
      apiCommonService.fetchSysTime().then((serverTimeMs) => {
        const sysTime = Math.ceil(serverTimeMs / 1000);
        if (!sysTime || !this.formikRef.current.values.START_DATE) return;
        const startDate = moment(this.formikRef.current.values.START_DATE).startOf('day');
        const effectiveDays = startDate.diff(moment.unix(sysTime), 'days') + 1;
        const mustLogin = effectiveDays < this.state.travelPeriod;
        if (!mustLogin) this.handleInsuredByLoginModal();
      });
    };

    handleFilterInsuredSubjectOpts = (originalOpts: SysOptionModel[], date: Moment, sysTimeSec: number, travelPeriod: number) => {
      let opts = [...originalOpts];
      if (sysTimeSec && date) {
        const sysDate = moment.unix(sysTimeSec).startOf('day');
        const startDate = date.startOf('day');
        const effectiveDays = startDate.diff(sysDate, 'days');
        opts = effectiveDays < travelPeriod
          ? _.cloneDeep(originalOpts).filter((_, index) => index === 0)
          : [...originalOpts];
      }
      return opts;
    };

    /*
     * @description 從 server 取得時間
     */
    getSysTime = async () => {
      const sysTime = Math.ceil(await apiCommonService.fetchSysTime() / 1000);
      this.setState(prevState => {
        return {
          ...prevState,
          sysTime: sysTime
        };
      });
    }

    handlePreviewFillExample = () => {
      this.props.setExplainModalVisible(true);
    }

    handlePreviewInsureHelper = () => {
      this.props.setInsureHelperModalVisible(true);
    }

    handlePreviewAbroad = () => {
      this.props.setAbroadModalVisible(true);
    }

    handleProductExplain = () => {
      this.props.setProductExplainVisible(true);
    }

    handleConfirm = async () => {
      const errors = await this.formikRef.current.validateForm();

      if (Object.keys(errors).length !== 0) return this.formikRef.current.setTouched(setNestedObjectValues<FormikTouched<ICalcFormValue>>(errors, true));

      this.props.setConfirmModalVisible(true);
    }

    /**
     * @description 左移試算方案一筆
     */
    handlePremiumPreviousClick = () => {
      if (this.state.viewIndex > 0) {
        this.setState(prevState => {
          return {
            ...prevState,
            viewIndex: prevState.viewIndex - 3
          };
        });
      }
    };

    /**
     * @description 右移試算方案一筆
     */
    handlePremiumNextClick = () => {
      if (this.state.viewIndex + maxViewSize < this.state.evalExpanData.length) {
        this.setState(prevState => {
          return {
            ...prevState,
            viewIndex: prevState.viewIndex + 3
          };
        });
      }
    };

    // 新增 window scroll 事件監聽
    addWindowScrollEvent = () => {
      window.addEventListener('scroll', this.toggleProgramFixed, false);
    }

    // 移除 window scroll 事件監聽
    removeWindowScrollEvent = () => {
      window.removeEventListener('scroll', this.toggleProgramFixed, false);
    }

    // 視窗滾動低於「投保資訊」區塊以下時，顯示「投保資訊」方案摘要區塊 (Fixed 在 Header 下方)
    toggleProgramFixed = () => {
      const headerHeight = 72;
      const calcHeaderBottom = (window.pageYOffset + this.calcListMobileRef.current?.getBoundingClientRect().top) - headerHeight;
      const scrollTopPosition = window.pageYOffset;

      if (scrollTopPosition > calcHeaderBottom && !this.state.programFixed) {
        if (this.calcListMobileRef.current) this.calcListMobileRef.current.style.paddingTop = this.calcMobileHeaderRef.current?.clientHeight + 'px';

        this.setState(state => ({
          ...state,
          programFixed: true
        }));
      };

      if (!(scrollTopPosition > calcHeaderBottom) && this.state.programFixed) {
        if (this.calcListMobileRef.current) this.calcListMobileRef.current.style.paddingTop = '0px';

        this.setState(state => ({
          ...state,
          programFixed: false
        }));
      };
    }

    render () {
      // #region 產生保費試算結果區塊

      /**
         * @description 新增/移除我的收藏
         * @param active 是否為收藏
         * @param insTypeId 險種類別
         * @param prodId 商品代碼
         * @param planId 計畫代碼
        */
      const handleSetFavorite = (active: any, insTypeId: string, prodId: string, planId: string) => {
        const isLogin = storageService.getItem(storageKeys.LoginInfo);

        if (!isLogin) {
          sweetAlertService.modal({
            html: 'HI~請問是否登入會員，以確保下次登入時還能看到收藏的內容唷！',
            showCancelButton: true,
            showCloseButton: true
          }).then(res => {
            if (res.value) {
              this.props.unloginAddItem && this.props.unloginAddItem(insTypeId, prodId, planId);
              const path = {
                pathname: RouterSettings.Login,
                state: { originUrl: RouterSettings.InsureProcess.Travel }
              };

              this.props.history.push(path);
            }
          });

          return;
        }

        if (active) {
          // 移除用的 SN 或 planId
          sweetAlertService.modal({
            html: 'Hi~您確定要取消收藏嗎?',
            showCancelButton: true,
            showCloseButton: true
          }).then(res => {
            if (res.value) {
              const removeId = commonService.getFavoriteItemSN(this.props.myFavoriteList, insTypeId, prodId, planId);

              this.props.onRemoveFavoriteItem(removeId);
            }
          });
        } else {
          // 新增我的收藏用 Model
          const addFavoriteItem: AddFavoriteItem = commonService.getAddFavoriteItem(insTypeId, prodId, planId);
          // 新增
          this.props.onAddFavoriteItem(addFavoriteItem);
        }
      };

      /**
         * @description 切換 PC Fold 組件開啟/關閉
         * @param foldIndex 資料中使用 Fold 組件的 Row index
         */
      // const handlePcFoldToggle = (foldIndex: number) => {
      //   const updatedPcDetailFoldsOpen = [...this.state.pcDetailFoldsOpen];
      //   updatedPcDetailFoldsOpen[foldIndex] = !updatedPcDetailFoldsOpen[foldIndex];
      //   this.setState(prevState => {
      //     return {
      //       ...prevState,
      //       pcDetailFoldsOpen: updatedPcDetailFoldsOpen
      //     };
      //   });
      // };

      /**
         * @description 切換 Mobile Fold 組件開啟/關閉
         * @param foldIndex 資料中使用 Fold 組件的 Row index
         */
      // const handleMobileFoldToggle = (foldIndex: number) => {
      //   const updatedMobileDetailFoldsOpen = [...this.state.mobileDetailFoldsOpen];
      //   updatedMobileDetailFoldsOpen[foldIndex] = !updatedMobileDetailFoldsOpen[foldIndex]

      //   this.setState(prevState => {
      //     return {
      //       ...prevState,
      //       mobileDetailFoldsOpen: updatedMobileDetailFoldsOpen
      //     };
      //   });
      // };

      /**
       *
       */
      const handleCreateBody = (target: BodyBaseContent[]) => {
        const calcResBody: JSX.Element[] = [];
        const startIndex = this.state.viewIndex;
        const endIndex = startIndex + maxViewSize;
        const premIndex = this.state.premIndex;
        _.forEach(target, (bodyContent: BodyContent, bodyContentIndex: number) => {
          switch (bodyContent.TYPE) {
            case EvalInfoBodyType.ROW: {
              const child: JSX.Element[] = [];
              child.push(
                <div key={`${bodyContentIndex}`} className="premium-calc-list__col">{bodyContent.ROWTITLE}</div>
              );
              _.forEach(bodyContent.FIELD, (field: string, fieldIndex: number) => {
                if (fieldIndex >= startIndex && fieldIndex < endIndex) {
                  child.push(
                    <div key={`${bodyContentIndex}${fieldIndex}`} className={'premium-calc-list__col' + (fieldIndex === premIndex ? ' prem' : '')}>{field ?? '-'}</div>
                  );
                }
              });

              const blankLength = 4 - child.length;

              if (child.length > 0 && blankLength > 0 && blankLength < 3) {
                const lastIndex = bodyContent.FIELD.length;

                child.push(
                  ...Array.from({ length: blankLength }, (_v, i) => (
                    <div key={`${bodyContentIndex}${lastIndex + i}`} className={'premium-calc-list__col' + (lastIndex + i === premIndex ? ' prem' : '')} />
                  ))
                );
              }

              calcResBody.push(
                <div className="premium-calc-list__row" key={`bodyO15-${bodyContentIndex}`}>
                  {child}
                </div>
              );
              break;
            }
            case EvalInfoBodyType.FOLDABLE: {
              const itemLength = this.state.evalInfo.EVAL_RESULT.HEADER[0].length - 1;
              const blankLength = 3 - (itemLength) % 3;

              itemArray = new Array(itemLength + blankLength);

              arrowIndexs = handleGetArrowIndexs(itemArray.length, bodyContent.BODY);

              const childTitle = (
                <div className="premium-calc-list__body-foldable-title" key={`${bodyContentIndex}`}>
                  {
                    !isSPI ? (
                      <>
                        <div className="premium-calc-list__col">
                          <span>{bodyContent.ROWTITLE}</span>
                          {/* <button
                            type="button"
                            className={'element__icon-button' + (this.state.pcDetailFoldsOpen[bodyContentIndex] ? ' element__icon-button--close' : ' element__icon-button--add')}
                            onClick={() => handlePcFoldToggle(bodyContentIndex)}
                          >
                            {this.state.pcDetailFoldsOpen[bodyContentIndex] ? '關閉詳細資訊' : '開啟詳細資訊'}
                          </button> */}
                        </div>
                        {
                          _.map(itemArray, (val: any, index: number) => {
                            if (!(index >= startIndex && index < endIndex)) return;
                            if (arrowIndexs.indexOf(index) !== -1) {
                              return (
                                <div className={'premium-calc-list__col' + (index === premIndex ? ' prem' : '')}>
                                  <div className="premium-calc-list__body-foldable-title__check" key={index} />
                                </div>
                              );
                            }
                            if (index < itemLength) {
                              return (
                                <div className={'premium-calc-list__col' + (index === premIndex ? ' prem' : '')}>
                                  <div className="premium-calc-list__body-foldable-title__dash" key={index} />
                                </div>
                              );
                            }
                            return (
                              <div className="premium-calc-list__col" />
                            );
                          })
                        }
                      </>
                    ) : <span>{bodyContent.ROWTITLE}</span>
                  }
                </div>
              );
              const childContent: JSX.Element[] = [];
              let childInside: JSX.Element[] = [];
              _.forEach(bodyContent.BODY, (bodyBaseContent: BodyBaseContent, bodyBaseContentIndex: number) => {
                childInside = [];
                childInside.push(
                  <div className="premium-calc-list__col" key={`${bodyBaseContentIndex}`}>{bodyBaseContent.ROWTITLE}</div>
                );
                _.forEach(bodyBaseContent.FIELD, (field: string, fieldIndex: number) => {
                  if (fieldIndex >= startIndex && fieldIndex < endIndex) {
                    childInside.push(
                      <div className={'premium-calc-list__col' + (fieldIndex === premIndex ? ' prem' : '')} key={`${bodyBaseContentIndex}${fieldIndex}`}>{field ?? '-'}</div>
                    );
                  }
                });

                const insideBlankLength = 4 - childInside.length;

                if (childInside.length > 0 && insideBlankLength > 0 && insideBlankLength < 3) {
                  childInside.push(
                    ...Array.from({ length: insideBlankLength }, (_v, i) => (
                      <div className="premium-calc-list__col" key={`${bodyBaseContentIndex}${bodyBaseContent.FIELD.length + i}`} />
                    ))
                  );
                }

                childContent.push(
                  <div className="premium-calc-list__row" key={`bodyBaseContent${bodyBaseContentIndex}`}>
                    {childInside}
                  </div>
                );
              });

              calcResBody.push(
                <div className="premium-calc-list__body-foldable" key={`body${bodyContentIndex}`}>
                  {childTitle}
                  <div className="premium-calc-list__body-foldable-content">
                    {/* <Fold isOpen={isSPI || this.state.pcDetailFoldsOpen[bodyContentIndex] as boolean}> */}
                    {childContent}
                    {/* </Fold> */}
                  </div>
                </div>
              );
              break;
            }
          }
        });
        return calcResBody;
      };

      const handleCreateMobileBody = (target: BodyBaseContent[]) => {
        const calcResBody: JSX.Element[] = [];
        const startIndex = this.state.viewIndex;
        const endIndex = startIndex + maxViewSize;
        target.forEach((bodyContent: BodyContent, bodyContentIndex: number) => {
          switch (bodyContent.TYPE) {
            case EvalInfoBodyType.ROW: {
              const child: JSX.Element[] = [];
              calcResBody.push(
                <div key={`${bodyContentIndex}`} className="premium-calc-list-mobile__row-title">{bodyContent.ROWTITLE}</div>
              );
              _.forEach(bodyContent.FIELD, (field: string, fieldIndex: number) => {
                if (fieldIndex >= startIndex && fieldIndex < endIndex) {
                  child.push(
                    <div key={`${bodyContentIndex}${fieldIndex}`} className="premium-calc-list-mobile__col">{field ?? '-'}</div>
                  );
                }
              });

              const blankLength = 3 - child.length;

              if (child.length > 0 && blankLength > 0 && blankLength < 3) {
                child.push(
                  ...Array.from({ length: blankLength }, (_v, i) => (
                    <div key={`${bodyContentIndex}${bodyContent.FIELD.length + i}`} className="premium-calc-list-mobile__col" />
                  ))
                );
              }

              calcResBody.push(
                <div className="premium-calc-list-mobile__row" key={`bodyO15-${bodyContentIndex}`}>
                  {child}
                </div>
              );
              break;
            }
            case EvalInfoBodyType.FOLDABLE: {
              arrowIndexs = handleGetArrowIndexs(this.state.evalExpanData.length, bodyContent.BODY);

              const childTitleLength = this.state.evalExpanData.length;
              const titleBlankLength = 3 - childTitleLength % 3;
              const childTitleContent = Array.from({ length: childTitleLength + titleBlankLength }, (_v, i) => {
                if (!(i >= startIndex && i < endIndex)) return <></>;
                if (arrowIndexs.indexOf(i) !== -1) {
                  return (
                    <div className="premium-calc-list-mobile__col" key={i}>
                      <div className="premium-calc-list-mobile__body-foldable-title__check" />
                    </div>
                  );
                }
                if (i < childTitleLength) {
                  return (
                    <div className="premium-calc-list-mobile__col" key={i}>
                      <div className="premium-calc-list-mobile__body-foldable-title__dash" />
                    </div>
                  );
                }
                return (
                  <div className="premium-calc-list-mobile__col" key={i} />
                );
              });

              const childTitle = (
                <div className="premium-calc-list-mobile__body-foldable-title" key={`${bodyContentIndex}`}>
                  {
                    !isSPI ? (
                      <>
                        <div className="premium-calc-list-mobile__row-title">
                          <span>{bodyContent.ROWTITLE}</span>
                          {/* <button
                            type="button"
                            className={'element__icon-button' + (this.state.mobileDetailFoldsOpen[bodyContentIndex] ? ' element__icon-button--close' : ' element__icon-button--add')}
                            onClick={() => handleMobileFoldToggle(bodyContentIndex)}
                          >
                            {this.state.mobileDetailFoldsOpen[bodyContentIndex] ? '關閉詳細資訊' : '開啟詳細資訊'}
                          </button> */}
                        </div>
                        <div className="premium-calc-list-mobile__row">
                          {childTitleContent}
                        </div>
                      </>
                    ) : <span>{bodyContent.ROWTITLE}</span>
                  }
                </div>
              );
              const childContent: JSX.Element[] = [];
              let childInside: JSX.Element[] = [];

              bodyContent.BODY && bodyContent.BODY.forEach((bodyBaseContent: BodyBaseContent, bodyBaseContentIndex: number) => {
                childInside = [];
                childContent.push(
                  <div className="premium-calc-list-mobile__row-title" key={`${bodyBaseContentIndex}`}>{bodyBaseContent.ROWTITLE}</div>
                );
                bodyBaseContent.FIELD.forEach((field: string, fieldIndex: number) => {
                  if (fieldIndex >= startIndex && fieldIndex < endIndex) {
                    childInside.push(
                      <div className="premium-calc-list-mobile__col" key={`${bodyBaseContentIndex}${fieldIndex}`}>{field ?? '-'}</div>
                    );
                  }
                });

                const childBlankLength = 3 - childInside.length;

                if (childInside.length > 0 && childBlankLength > 0 && childBlankLength < 3) {
                  childInside.push(
                    ...Array.from({ length: childBlankLength }, (_v, i) => (
                      <div className="premium-calc-list-mobile__col" key={`${bodyBaseContentIndex}${bodyBaseContent.FIELD.length + i}`} />
                    ))
                  );
                }

                childContent.push(
                  <div className="premium-calc-list-mobile__row" key={`bodyBaseContent${bodyBaseContentIndex}`}>
                    {childInside}
                  </div>
                );
              });

              calcResBody.push(
                <div className="premium-calc-list-mobile__body-foldable" key={`body${bodyContentIndex}`}>
                  {childTitle}
                  <div className="premium-calc-list-mobile__body-foldable-content">
                    {/* <Fold isOpen={isSPI || this.state.mobileDetailFoldsOpen[bodyContentIndex] as boolean}> */}
                    {childContent}
                    {/* </Fold> */}
                  </div>
                </div>
              );
              break;
            }
          }
        });
        return calcResBody;
      };

      /**
         * @description 取得要放置勾勾的項目 index
        */
      const handleGetArrowIndexs = (evalLength: number, bodys: BodyBaseContent[] = new Array(0)) => {
        if (bodys.length === 0) return new Array(0);

        // 攤平 body field 陣列資料
        const fieldArray = new Array(0);
        for (let i = 0; i < evalLength; i += 1) {
          const bodyFields = new Array(0);
          _.forEach(bodys, (body: BodyBaseContent) => {
            bodyFields.push(body.FIELD[i]);
          });
          fieldArray.push(bodyFields);
        }

        // 判斷內容有值得 index
        const indexsArray = new Array(0);
        _.forEach(fieldArray, (res: any, index: number) => {
          if (_.some(res, (val: any) => val && val.length > 0)) {
            indexsArray.push(index);
          }
        });
        return indexsArray;
      };

      const calcResHeader: JSX.Element[] = [];
      const calcResFooter: JSX.Element[] = [];
      const mobileHeader: JSX.Element[] = [];
      const mobileFooter: JSX.Element[] = [];
      const isSPI = this.state.prodId === TravelPlanType.SPI;
      let arrowIndexs = new Array(0);
      let itemArray = new Array(0);
      let calcResMobile;
      let calcResArea;
      if (this.state.evalInfo) {
        // #region  試算結果-PC

        // #region 保費試算結果-header
        const startIndex = this.state.viewIndex;
        const endIndex = startIndex + maxViewSize;
        _.forEach(this.state.evalInfo.EVAL_RESULT.HEADER, (headers: HeaderContent[]) => {
          _.map(headers, (header: HeaderContent, headerIndex: number) => {
            // 處理左標題(即第一筆資料)
            if (headerIndex === 0) {
              calcResHeader.push(
                <div className="premium-calc-list__col" key={headerIndex}>
                  <div className="premium-calc-list__plan">
                    <span>{header.TITLE}</span>
                    {this.state.prodId === TravelPlanType.Abroad && <span>向右可查看更多方案→</span>}
                    {this.state.prodId === TravelPlanType.Abroad && <button onClick={this.handleProductExplain}>商品特色說明</button>}
                    {/* 隱藏投保QA */}
                    {/* <span>{commonService.htmlParser(commonService.getCodeMsg(this.props.UICode, CodeId.U045))}</span> */}
                  </div>
                </div>
              );
            } else {
              const currentIndex = headerIndex - 1;
              if (currentIndex >= startIndex && currentIndex < endIndex) {
                const isActive = commonService.matchFavorite(
                  this.props.myFavoriteList,
                  this.state.evalInfo.EVAL_RESULT.INS_TYPE_ID,
                  this.state.evalInfo.EVAL_RESULT.PROD_ID,
                  header.PLAN_ID
                );

                calcResHeader.push(
                  <div style={{ position: 'relative' }} className="premium-calc-list__col" key={headerIndex}>
                    {currentIndex === startIndex && (
                      <button className="premium-calc-list__prev-btn" onClick={this.handlePremiumPreviousClick} disabled={currentIndex === 0} />
                    )}
                    <button
                      type="button"
                      className={'premium-calc-list__favorite-btn' + (isActive ? ' premium-calc-list__favorite-btn--active' : '')}
                      onClick={() => handleSetFavorite(isActive, this.state.evalInfo.EVAL_RESULT.INS_TYPE_ID, this.state.evalInfo.EVAL_RESULT.PROD_ID, header.PLAN_ID)}
                    />
                    <div className="premium-calc-list__program">
                      <span className="title-mark">{header.TITLE}
                        {
                          ['PB', 'PA'].includes(header.PLAN_ID) && (
                            <div className="mark">{commonService.getCodeMsg(this.state.WPACodes, header.PLAN_ID)}</div>
                          )
                        }
                      </span>
                      {/* <span>{header.SUBTITLE}</span> */}
                      <span style={{ whiteSpace: 'nowrap' }}>{header.TOTAL}</span>
                      {/* <button type="button" className="element__button element__button--black" onClick={() => this.handleInsured(header.PLAN_ID)}>我要保這個</button> */}
                      <button type="button" className="element__button element__button--red" onClick={() => this.handleInsured(header.PLAN_ID)}>保這個</button>
                    </div>
                    {currentIndex === endIndex - 1 && (
                      <button className="premium-calc-list__next-btn" onClick={this.handlePremiumNextClick} disabled={(this.state.evalExpanData.length - 1) - currentIndex <= 0} />
                    )}
                  </div>
                );
              }
            }
          });

          const blankLength = 4 - calcResHeader.length;

          if (calcResHeader.length > 0 && blankLength < 3 && blankLength > 0) {
            const lastIndex = headers.length;

            calcResHeader.push(
              ...Array.from({ length: blankLength }, (_v, i) => {
                const currentIndex = lastIndex + i - 1;

                return (
                  <div style={{ position: 'relative' }} className="premium-calc-list__col" key={lastIndex + i}>
                    {currentIndex === startIndex && (
                      <button className="premium-calc-list__prev-btn" onClick={this.handlePremiumPreviousClick} disabled={currentIndex === 0} />
                    )}
                    {currentIndex === endIndex - 1 && (
                      <button className="premium-calc-list__next-btn" onClick={this.handlePremiumNextClick} disabled={(this.state.evalExpanData.length - 1) - currentIndex <= 0} />
                    )}
                  </div>
                );
              })
            );
          }
        });

        // #endregion

        // #region 保費試算結果-footer

        _.forEach(this.state.evalInfo.EVAL_RESULT.FOOTER, (footers: FooterContent[], footersIndex: number) => {
          const child: JSX.Element[] = [];
          _.map(footers, (footer: FooterContent, footerIndex: number) => {
            if (footerIndex === 0) {
              child.push(<div key={footerIndex} className="premium-calc-list__col">{footer.TITLE}</div>);
            } else {
              const currentIndex = footerIndex - 1;

              if (currentIndex >= startIndex && currentIndex < endIndex) {
                const footerVal = footer.TITLE ? footer.TITLE : footer.SUBTOTAL ? footer.SUBTOTAL : footer.TOTAL;
                child.push(<div key={footerIndex} className="premium-calc-list__col">{footerVal}</div>);
              }
            }
          });

          const blankLength = 4 - child.length;

          if (child.length > 0 && blankLength < 3 && blankLength > 0) {
            const lastIndex = footers.length;

            child.push(
              ...Array.from({ length: blankLength }, (_v, i) => {
                return (
                  <div className="premium-calc-list__col" key={lastIndex + i} />
                );
              })
            );
          }

          calcResFooter.push(
            <div className="premium-calc-list__row" key={footersIndex}>
              {child}
            </div>
          );
        });

        // #endregion
        if (calcResHeader.length > 0 && calcResFooter.length > 0) {
          const calcResBodyO15: JSX.Element[] = +this.formikRef.current.values.OVER15_COUNT > 0 ? handleCreateBody(this.state.evalInfo.EVAL_RESULT.BODY_O15) : [];
          const calcResBodyU15: JSX.Element[] = +this.formikRef.current.values.UNDER15_COUNT > 0 ? handleCreateBody(this.state.evalInfo.EVAL_RESULT.BODY_U15) : [];
          const calcResBodySubTO15: JSX.Element[] = +this.formikRef.current.values.OVER15_COUNT > 0 ? handleCreateBody(this.state.evalInfo.EVAL_RESULT.SUBTOTAL_O15[0]) : [];
          const calcResBodySubTU15: JSX.Element[] = +this.formikRef.current.values.UNDER15_COUNT > 0 ? handleCreateBody(this.state.evalInfo.EVAL_RESULT.SUBTOTAL_U15[0]) : [];
          calcResArea = (
            <div className="premium-calc-list">
              <div className="premium-calc-list__header">
                {calcResHeader}
              </div>
              {
                +this.formikRef.current.values.OVER15_COUNT > 0 && (
                  <div className="premium-calc-list__body over-15">
                    <>
                      <h5>15歲以上投保方案</h5>
                      <div className="premium-calc-list__table">
                        {calcResBodyO15}
                      </div>
                    </>
                  </div>
                )
              }
              {
                +this.formikRef.current.values.OVER15_COUNT > 0 && (
                  <div className="premium-calc-list__body">
                    {calcResBodySubTO15}
                  </div>
                )
              }
              {
                +this.formikRef.current.values.UNDER15_COUNT > 0 && (
                  <div className="premium-calc-list__body under-15">
                    <>
                      <h5>未滿15歲投保方案</h5>
                      <div className="premium-calc-list__table">
                        {calcResBodyU15}
                      </div>
                    </>
                  </div>
                )
              }
              {
                +this.formikRef.current.values.UNDER15_COUNT > 0 && (
                  <div className="premium-calc-list__body">
                    {calcResBodySubTU15}
                  </div>
                )
              }
              <div className="premium-calc-list__footer">
                {calcResFooter}
              </div>
            </div>
          );
        }

        // #endregion

        // 不該在 render() 內呼叫 setState()，試算完就應該要攤平結果
        // #region 將試算結果攤平

        // if (this.state.evalInfo &&
        //         this.state.evalInfo.EVAL_RESULT &&
        //         this.state.evalInfo.EVAL_RESULT.INS_TYPE_ID &&
        //         this.state.evalExpanData &&
        //         this.state.evalExpanData.length === 0) {
        //   this.setState(prevState => {
        //     return {
        //       ...prevState,
        //       evalExpanData: commonService.expandEvalResult(this.state.evalInfo) || new Array(0)
        //     };
        //   });
        // }

        // #endregion

        // #region 產生試算結果-Mobile
        // #region 產生 header 區塊
        this.state.evalExpanData.forEach((evalRes: EvalExpans, index: number) => {
          if (index >= startIndex && index < endIndex) {
            const isActive = commonService.matchFavorite(
              this.props.myFavoriteList,
              this.state.evalInfo.EVAL_RESULT.INS_TYPE_ID,
              this.state.evalInfo.EVAL_RESULT.PROD_ID,
              evalRes.HEADER.PLAN_ID
            );

            mobileHeader.push(
              <div style={{ position: 'relative' }} className="premium-calc-list-mobile__col" key={evalRes.HEADER.PLAN_ID}>
                {index === startIndex && (
                  <button className="premium-calc-list-mobile__prev-btn" onClick={this.handlePremiumPreviousClick} disabled={index === 0} />
                )}
                <div className="premium-calc-list-mobile__program">
                  <button
                    type="button"
                    className={'premium-calc-list-mobile__favorite-btn' + (isActive ? ' premium-calc-list-mobile__favorite-btn--active' : '')}
                    onClick={() => handleSetFavorite(isActive, this.state.evalInfo.EVAL_RESULT.INS_TYPE_ID, this.state.evalInfo.EVAL_RESULT.PROD_ID, evalRes.HEADER.PLAN_ID)}
                  />
                  <span className="title-mark">{evalRes.HEADER.TITLE}
                    {
                      ['PB', 'PA'].includes(evalRes.HEADER.PLAN_ID) && (
                        <div className="mark">{commonService.getCodeMsg(this.state.WPACodes, evalRes.HEADER.PLAN_ID)}</div>
                      )
                    }
                  </span>
                  {/* <span>{evalRes.HEADER.SUBTITLE}</span> */}
                  <span style={{ whiteSpace: 'nowrap' }}>{evalRes.HEADER.TOTAL}</span>
                  {/* <button type="button" className="element__button element__button--black" onClick={() => this.handleInsured(evalRes.HEADER.PLAN_ID)}>我要保這個</button> */}
                  <button type="button" className="element__button element__button--red" onClick={() => this.handleInsured(evalRes.HEADER.PLAN_ID)}>保這個</button>
                </div>
                {index === endIndex - 1 && (
                  <button className="premium-calc-list-mobile__next-btn" onClick={this.handlePremiumNextClick} disabled={(this.state.evalExpanData.length - 1) - index <= 0} />
                )}
              </div>
            );
          }
        });

        const blankLength = 3 - mobileHeader.length;

        if (mobileHeader.length > 0 && blankLength < 3 && blankLength > 0) {
          const lastIndex = this.state.evalExpanData.length;

          mobileHeader.push(
            ...Array.from({ length: blankLength }, (_v, i) => {
              const currentIndex = lastIndex + i - 1;

              return (
                <div style={{ position: 'relative' }} className="premium-calc-list-mobile__col" key={this.state.evalExpanData.length + i}>
                  {currentIndex === startIndex && (
                    <button className="premium-calc-list-mobile__prev-btn" onClick={this.handlePremiumPreviousClick} disabled={currentIndex === 0} />
                  )}
                  {currentIndex === endIndex - 1 && (
                    <button className="premium-calc-list-mobile__next-btn" onClick={this.handlePremiumNextClick} disabled={(this.state.evalExpanData.length - 1) - currentIndex <= 0} />
                  )}
                </div>
              );
            })
          );
        }

        // #endregion

        // #region 產生 footer 區塊
        this.state.evalInfo.EVAL_RESULT.FOOTER.forEach((footers: FooterContent[], footersIndex: number) => {
          const child: JSX.Element[] = [];
          footers.forEach((footer: FooterContent, footerIndex: number) => {
            if (footer.TITLE) {
              mobileFooter.push(
                <div className="premium-calc-list-mobile__row-title" key={footersIndex}>
                  {footer.TITLE}
                </div>
              );
            }
            if (footerIndex - 1 >= startIndex && footerIndex <= endIndex) {
              child.push(<div key={footerIndex} className="premium-calc-list-mobile__col">{footer.SUBTOTAL ? footer.SUBTOTAL : footer.TOTAL}</div>);
            }
          });

          const blankLength = 3 - child.length;

          if (child.length > 0 && blankLength > 0 && blankLength < 3) {
            child.push(
              ...Array.from({ length: blankLength }, (_v, i) => (
                <div key={footers.length + i} className="premium-calc-list-mobile__col" />
              ))
            );
          }

          mobileFooter.push(
            <div className="premium-calc-list-mobile__row" key={footersIndex}>
              {child}
            </div>
          );
        });
        // #endregion

        if (
          mobileHeader.length > 0
          // && calcResFooter.length > 0
        ) {
          const calcResMobileBodyO15: JSX.Element[] = +this.formikRef.current.values.OVER15_COUNT > 0 ? handleCreateMobileBody(this.state.evalInfo.EVAL_RESULT.BODY_O15) : [];
          const calcResMobileBodyU15: JSX.Element[] = +this.formikRef.current.values.UNDER15_COUNT > 0 ? handleCreateMobileBody(this.state.evalInfo.EVAL_RESULT.BODY_U15) : [];
          const calcResMobileBodySubTO15: JSX.Element[] = +this.formikRef.current.values.OVER15_COUNT > 0 ? handleCreateMobileBody(this.state.evalInfo.EVAL_RESULT.SUBTOTAL_O15[0]) : [];
          const calcResMobileBodySubTU15: JSX.Element[] = +this.formikRef.current.values.UNDER15_COUNT > 0 ? handleCreateMobileBody(this.state.evalInfo.EVAL_RESULT.SUBTOTAL_U15[0]) : [];
          calcResMobile = (
            <div className="premium-calc-list-mobile" ref={this.calcListMobileRef}>
              <div className={'premium-calc-list-mobile__header' + (this.state.programFixed ? ' premium-calc-list-mobile__header-fixed' : '')} ref={this.calcMobileHeaderRef}>
                {mobileHeader}
              </div>
              {
                +this.formikRef.current.values.OVER15_COUNT > 0 && (
                  <div className="premium-calc-list-mobile__body over-15">
                    <>
                      <h5>15歲以上投保方案</h5>
                      {calcResMobileBodyO15}
                    </>
                  </div>
                )
              }
              {
                +this.formikRef.current.values.OVER15_COUNT > 0 && (
                  <div className="premium-calc-list-mobile__body">
                    {calcResMobileBodySubTO15}
                  </div>
                )
              }
              {
                +this.formikRef.current.values.UNDER15_COUNT > 0 && (
                  <div className="premium-calc-list-mobile__body under-15">
                    <>
                      <h5>未滿15歲投保方案</h5>
                      {calcResMobileBodyU15}
                    </>
                  </div>
                )
              }
              {
                +this.formikRef.current.values.UNDER15_COUNT > 0 && (
                  <div className="premium-calc-list-mobile__body">
                    {calcResMobileBodySubTU15}
                  </div>
                )
              }
              <div className="premium-calc-list-mobile__footer">
                {mobileFooter}
              </div>
            </div>
          );
        }

      // // #endregion
      }
      // #endregion

      const validationSchema = Yup.object().shape({
        PROD_ID: Yup.string().required('此為必填欄位'),
        // INSURED_RANGE: Yup.string().required('此為必填欄位').nullable()
        //   .test('Period > 0', '投保天數不得小於 1 天', (val: string) => {
        //     if (val && val.indexOf(',') !== -1) {
        //       const moments = val.split(',');
        //       return (moment(moments[1]).diff(moment(moments[0]), 'd')) >= 1;
        //     }

        //     return true;
        //   })
        //   .test('Period > Expired Date', `投保天數不得大於 ${this.state.maxPeriod} 天`, (val: string) => {
        //     if (val && val.indexOf(',') !== -1) {
        //       const moments = val.split(',');
        //       return (moment(moments[1]).diff(moment(moments[0]), 'd')) <= this.state.maxPeriod;
        //     }

        //     return true;
        //   }),
        // INSURED_TIME: Yup.string().required('此為必填欄位').test('reasonable time', '請重新選擇時間', (val: any) => {
        //   if (this.formikRef && this.formikRef.current && this.formikRef.current.values && val) {
        //     return commonService.getDisableTime(this.formikRef.current.values.INSURED_RANGE).indexOf(+moment(val).format('HH')) === -1;
        //   }
        //   return true;
        // }).nullable(),
        START_DATE: Yup.string().required('此為必填欄位').nullable(),
        END_DATE: Yup.string().required('此為必填欄位').nullable(),
        INSURED_TIME: Yup.string().required('此為必填欄位').nullable(),
        INS_COUNT: Yup.string().required('此為必填欄位'),
        INSURED_SUBJECT: Yup.string().required('此為必填欄位'),
        SPI_TYPE: Yup.string().when('SPI_ATTACHED', (spiAttached: string, schema: any) => {
          return showSpi && (spiAttached) ? schema.required('此為必填欄位') : schema;
        }),
        // TOURIST_DESTINATION: Yup.string().test('tourist destination', '此為必填欄位', () => {
        //   return this.state.tempTravels.length > 0;
        // }),
        // TOURIST_COUNTRY: Yup.string().test('tourist country', '此為必填欄位', () => {
        //   return this.state.tempTravels.length > 0;
        // }),
        TOURIST_SELECT: Yup.string().test('filter select', '此為必填欄位', () => {
          return this.state.tempTravels.length > 0;
        })
        // || this.state.prodId === TravelPlanType.SPI
      });

      /**
         * @description 檢核登入狀態且為外國人，選取的商品種類是否可以投保
        */
      const handleCheckProdId = (e: React.ChangeEvent<HTMLSelectElement>) => {
        // 更新帶入的商品代碼
        if (e.currentTarget.value) {
          commonService.setActiveProdId(this.props.insTypeId, e.currentTarget.value);
        } else {
          commonService.setActiveProdId(this.props.insTypeId, this.props.prodId);
        }

        // 未登入不檢核
        if (!this.props.fetchFavoriteComplete || !storageService.getItem(storageKeys.MemberId)) return;

        const memberId = storageService.getItem(storageKeys.MemberId);
        const validChar = memberId ? memberId[1] : '';

        if (!validChar) return;
        const prodId = e.currentTarget.value;
        // 若為外國人，不可投保 國內 國外 申根
        const prodError = validChar &&
                (validChar !== IdInfoType.NationalMale && validChar !== IdInfoType.NationalFemale) &&
                (prodId === TravelPlanType.Domestic || prodId === TravelPlanType.Abroad || prodId === TravelPlanType.NTAG || prodId === TravelPlanType.TBP);

        this.setState(prevState => {
          return {
            prodError: prodError
          };
        });

        if (prodError) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            // html: '此商品尚未提供非本國人投保，請確認'
            html: `${commonService.getCodeMsg(this.props.UICode, CodeId.W073)}`
          });

          // 此商品代碼不可選，更新商品代碼為原帶入值
          commonService.setActiveProdId(this.props.insTypeId, this.props.prodId);
        }
      };

      /**
         * @description 若 一人 幫自己 或 多人 含自己，提示訊息是否登入
        */
      const handleShowLoginInfo = async (insCountVal: any, insSubjectVal?: any, setFieldValue?: any) => {
        if (this.props.fetchFavoriteComplete) return;

        if (!insCountVal || !insSubjectVal) return;

        if (insCountVal === InsCount.One && insSubjectVal === InsureSubject.Relatives) return;

        if (insCountVal === InsCount.MORE && insSubjectVal === InsureSubject.All) return;

        setFieldValue('INSURED_SUBJECT', '1');

        const isLogin = await sweetAlertService.modal({
          html: `${commonService.getCodeMsg(this.props.UICode, CodeId.W007)}`,
          showCancelButton: true,
          showCloseButton: true
        }).then(res => {
          if (res.value) {
            return true;
          }
        });

        if (isLogin) {
          if (insCountVal === InsCount.One && insSubjectVal === InsureSubject.Self) {
            setFieldValue('UNDER15_COUNT', '');
            setFieldValue('OVER15_COUNT', '1');
            this.setState(prevState => {
              return {
                ...prevState,
                evalInfo: initEvalInfo
              };
            });
          }

          const path = {
            pathname: RouterSettings.Login,
            state: { originUrl: RouterSettings.InsureProcess.Travel }
          };

          this.props.history.push(path);
        }
      };

      /**
         * @description 設定附加特定活動保險 是否可以勾選、勾選狀態設定，下拉選單值
        */
      const handleSetAttachSpec = (e: React.ChangeEvent<HTMLSelectElement>, setFieldValue: any) => {
        // 取得選取種類投保天數
        this.handleSetMaxPeriod(e.currentTarget.value);

        // 判斷 附加特定活動保險 是否可以勾選
        const isDisable = this.validAttachState(e.currentTarget.value);

        // 判斷勾選狀態，若為不可勾選，取消勾選狀態
        let isChecked = (this.state.attachSpecCheck && !isDisable);

        if (!isChecked) {
          setFieldValue('SPI_TYPE', '');
          setFieldValue('SPI_ATTACHED', isChecked);
        };

        // 險種類別為特定活動，不可勾選附加特定活動，但可選取活動類別
        if (e.currentTarget.value === TravelPlanType.SPI) {
          isChecked = false;
          setFieldValue('SPI_TYPE', '');
          setFieldValue('SPI_ATTACHED', false);
        }

        const targetVal = e.currentTarget.value;

        this.setState(prevState => {
          return {
            ...prevState,
            prodId: targetVal,
            attachSpecState: isDisable,
            attachSpecCheck: isChecked
          };
        });
      };

      /**
         * @description 取得保障金額
         */
      const handleFetchAmtOpt = async (e: React.ChangeEvent<HTMLSelectElement>, setFieldValue: any) => {
        if (!e.currentTarget.value) return;

        const amtOptResult = await service.fetchAmtOpt(this.props.insTypeId as InsType, e.currentTarget.value);
        if (!amtOptResult) return;

        _.forEach(amtOptResult.AMOUNTOPTION, (amtOpt: AmtOptContent) => {
          switch (amtOpt.UNDER15) {
            case AgeOptAge.OverFifteen:
              setFieldValue('OVER15_AMOUNT', amtOpt.DEFAULT_OPTION[0].VALUE);
              break;
            case AgeOptAge.UnderFifteen:
              setFieldValue('UNDER15_AMOUNT', amtOpt.DEFAULT_OPTION[0].VALUE);
              break;
          }
        });

        // 需更新 15 歲以下之喪葬保額 (2024/08/13)
        const mfuneralAmt = +amtOptResult.MFUNERALOPTION.filter(opt => opt.UNDER15 === '1')[0]?.DEFAULT_OPTION[0]?.VALUE ?? 0;
        setFieldValue('MFUNERAL', mfuneralAmt);

        // 更新所有保額選項，以利試算
        this.setState(prevState => {
          return {
            ...prevState,
            amtOpt: amtOptResult
          };
        });
      };
      // #region  保險期間相關方法

      /**
       * @description 等投保日期、時間都選定後顯示訊息
      */
      const handleShowPeriodMsg = (insTime?: moment.Moment) => {
        if (!this.state.insuredEndDate || !this.state.insuredStartDate || !insTime) return '';
        const startDate = moment(this.state.insuredStartDate).format('YYYY-MM-DD');
        const endDate = moment(this.state.insuredEndDate).format('YYYY-MM-DD');
        const period = moment(endDate).diff(moment(startDate), 'd');
        return (
          <p>共投保 <span style={{ color: '#FE3208' }}>{period}</span> 天，保障期間為 <span style={{ color: '#FE3208' }}>{moment(this.state.insuredStartDate).format('YYYY/MM/DD')} {moment(insTime).format('HH')}:00 - {moment(this.state.insuredEndDate).format('YYYY/MM/DD')} {moment(insTime).format('HH')}:00</span></p>
        );
      };

      // #endregion

      // #region 產生投保人數區塊

      const handleCreateInsCount = (handleChange: any, setFieldValue: any, values: any) => {
        const insCountSysOpts = commonService.sortSysOpts(this.state.oneOrMoreSysOpts);
        if (insCountSysOpts.length > 0) {
          return _.map(insCountSysOpts, (sysOption: SysOptionModel, index: number) => {
            return (
              <div className="element__radio-group" key={index}>
                <label htmlFor={sysOption.PARAM_ID}>
                  <div className="element__radio">
                    <Field
                      type="radio"
                      name="INS_COUNT"
                      id={sysOption.PARAM_ID}
                      value={sysOption.PARAM_VALUE}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        handleInsCountChange(e, sysOption.PARAM_ORDER, handleChange, setFieldValue);
                        this.handleExplainModalData(values.PROD_ID, e.target.value);
                      }}
                    />
                    <div className="element__radio-btn" />
                  </div>
                  <span>{sysOption.PARAM_TEXT}</span>
                </label>
              </div>
            );
          });
        }
      };

      const handleInsCountChange = async (e: any, paramOrder: any, handleChange: any, setFieldValue: any) => {
        handleChange(e);
        setFieldValue('ONEORMORE', paramOrder || 0);
        setFieldValue('OVER15_COUNT', '');
        setFieldValue('UNDER15_COUNT', '');
        setFieldValue('INSURED_SUBJECT', '');
        // handleShowLoginInfo(e.currentTarget.value);
        const val = e.currentTarget.value;
        // const insSubjectSysOpts = await service.fetchSubjectCode(val) || new Array(0);
        // const PClass = commonService.getSubjectPClass(this.formikRef.current.values.PROD_ID, val);
        // const insSubjectSysOpts = (PClass && await service.fetchSubjectCode(PClass)) || new Array(0);

        if (val === InsCount.One) {
          setFieldValue('OVER15_COUNT', '1');
          setFieldValue('UNDER15_COUNT', '0');
        }

        // 取得系統時間
        const serverTimeMs = await apiCommonService.fetchSysTime();
        const sysTime = Math.ceil(serverTimeMs / 1000);
        this.handleSubjectOpts(this.formikRef.current.values.PROD_ID, val, moment(this.formikRef.current.values.START_DATE), sysTime, this.state.travelPeriod);
        this.setState(prevState => {
          return {
            ...prevState,
            insCountState: val
          };
        });
      };

      // #endregion

      /**
         * @description 表單 Submit 事件
        */
      const handleFormSubmit = async (values: ICalcFormValue) => {
        const insurCount = +values.OVER15_COUNT + +values.UNDER15_COUNT;
        const serverTimeMs = await apiCommonService.fetchSysTime();

        // 判斷日期小於當天或日期等於當天但時間小於現在加1小時
        if (moment(values.START_DATE).format('YYYYMMDD') < moment(serverTimeMs).format('YYYYMMDD') ||
          (
            moment(values.START_DATE).format('YYYYMMDD') === moment(serverTimeMs).format('YYYYMMDD') &&
            +values.START_HOUR <= +moment(serverTimeMs).format('HH') + 1
          )) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            title: '投保時間錯誤',
            html: '投保起始時間最早為現在時間一小時後'
          });
          return;
        }

        if (!insurCount) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            title: '投保總人數錯誤',
            html: '投保人數最少 1 人'
          });
          return;
        }

        // 判斷投保人數是否大於 10 人
        if (insurCount > 10) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            title: '投保總人數錯誤',
            html: '投保人數最多 10 人'
          });
          return;
        }

        // 判斷一人投保時，投保人數是否大於 1 人
        if (values.INS_COUNT === InsCount.One && insurCount > 1) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            title: '投保總人數錯誤',
            html: '投保人數最多 1 人'
          });
          return;
        }

        // 判斷多人投保 且 投保對象為 5 人以上 時，投保人數是否小於 5 人
        // if (values.INS_COUNT === InsCount.MORE && values.INSURED_SUBJECT === InsureSubject.All && insurCount < 5) {
        //   sweetAlertService.modal({
        //     icon: SweetAlertIcon.Info,
        //     title: '投保總人數錯誤',
        //     html: '投保人數最低 5 人'
        //   });
        //   return;
        // }

        // 判斷一人投保，幫親屬保 或 多人投保，五人以上團體，投保起始日期是否為 7 天後
        const validInsuredDate = (values.INS_COUNT === InsCount.One && values.INSURED_SUBJECT === InsureSubject.Relatives) ||
                (values.INS_COUNT === InsCount.MORE && values.INSURED_SUBJECT === InsureSubject.All);
        if (validInsuredDate) {
          // 改取系統參數
          if (moment(moment().add(this.state.travelPeriod, 'd').format('YYYYMMDD')).isAfter(moment(values.START_DATE))) {
            sweetAlertService.modal({
              icon: SweetAlertIcon.Info,
              html: commonService.getCodeMsg(this.props.UICode, CodeId.U022)
            });

            return;
          }
        }

        // 判斷申根保險的旅遊地點
        if (prodId === TravelPlanType.NTAG) {
          const noSchengenArea = this.state.tempTravels.every(it => it.SCHENGEN !== YesNoType.Yes);
          if (noSchengenArea) {
            sweetAlertService.modal({
              icon: SweetAlertIcon.Info,
              html: commonService.getCodeMsg(this.props.UICode, CodeId.W086)
            });
            return;
          }
        }

        storageService.removeItem(storageKeys.TravelProgramCode);

        // 如有填入專案代碼，判斷專案代碼是否存在
        if (values.PROGRAM_ID) {
          const res = await apiCommonService.verifyProgramId(values.PROGRAM_ID, this.props.insTypeId);

          if (typeof res === 'string') {
            this.formikRef.current.setFieldError('PROGRAM_ID', res);
            return;
          }

          if (res && res.PROGRAM_ID) {
            storageService.setItem(storageKeys.TravelProgramCode, res.PROGRAM_ID);
          }
        }

        // 僅「國外」或「申根」檢核停賣規則
        if (prodId === TravelPlanType.Abroad || prodId === TravelPlanType.NTAG) {
          // 改為「每次」試算前先呼叫 API 取得最新停賣規則 (2025/04/08)
          const req = commonService.getApiReqData({});
          const config = commonService.getReqConfig();
          const response: BaseRes<InfoTraveloffQueryResp> = await apiService.fetchTraveloff(req, config);
          if (!response || !response.MWHEADER || !response.TRANRS) {
            sweetAlertService.modal({
              icon: SweetAlertIcon.Info,
              html: '系統發生錯誤，請稍後再試，如有疑問請洽客服。'
            });
          }
          // 僅 0000 與 1003 放行
          if (response.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess && response.MWHEADER.RETURNCODE !== ReturnCode.CodeNoInfo) {
            commonService.showErrorModal(response.MWHEADER.RETURNDESC, response.MWHEADER.RETURNCODE);
            return;
          }
          const latestRules: TradeoffRule[] = response.TRANRS.LIST ?? [];
          // 試算前檢核停賣規則
          const traveloffResult: TradeofResult = await validateTraveloffBeforeEval(values, latestRules);
          if (!traveloffResult.isPass) {
            // 轉換提示訊息為 html 結構，以利呈現
            const text = traveloffResult.messages.map(it => {
              return `<li class='text'>${it.text}</li>`;
            }).join('<br>');
            sweetAlertService.modal({
              icon: SweetAlertIcon.Info,
              html: `<div class='scroll-panel'><ul>${text}</ul></div>`,
              allowOutsideClick: false // 不允許點擊外部區域來關閉提示視窗
            });
            return;
          }
          // 前端追加部份方案的提示 (2025/07/29)
          if (traveloffResult.tips.length > 0) {
            // 轉換提示訊息為 html 結構，以利呈現
            const text = traveloffResult.tips.map(tip => {
              return `<li class='text'>${tip.text}</li>`;
            }).join('<br>');
            sweetAlertService.modal({
              icon: SweetAlertIcon.Info,
              html: `<div class='scroll-panel'><ul>${text}</ul></div>`,
              allowOutsideClick: true // 允許點擊外部區域來關閉提示視窗
            });
          };
        }

        // 追加勾選的地區國家於試算的上行電文
        const destinationId: string[] = [];
        this.state.tempTravels.forEach(it => {
          if (it && it.COUNTRY_ID) destinationId.push(it.COUNTRY_ID);
        });
        const evalReq: EvalReq = this.handleGetEvalReq(values, destinationId);
        // const evalReq = {
        //   INS_TYPE_ID: 'I01',
        //   PROD_ID: 'NTD',
        //   SPI_ATTACHED: '1',
        //   INSURE_PERIOD: 3,
        //   ONEORMORE: 2,
        //   INSURED_SUBJECT: '2',
        //   OVER15: {
        //     PEOPLE: 1,
        //     LIEF_AMOUNT: 2000000
        //   },
        //   UNDER15: {
        //     PEOPLE: 1,
        //     LIEF_AMOUNT: 1000000
        //   }
        //   // PROGRAM_ID: 'original'
        // };
        const result: EvalRes = await service.evalProd(evalReq);
        if (result && result.EVAL_RESULT) {
          // 試算完後需攤平結構
          this.setState(prevState => {
            return {
              ...prevState,
              evalInfo: result,
              evalExpanData: commonService.expandEvalResult(result) || new Array(0),
              viewIndex: 0,
              premIndex: result.EVAL_RESULT.HEADER[0].findIndex(item => item.PLAN_ID === 'XP') - 1
            };
          }, () => {
            // 滑動到試算結果區塊
            window.scroll({
              top: this.calcResRef.current.offsetTop + 100,
              behavior: 'smooth'
            });
            // 更新試算結果
            this.props.onCalc(
              this.formikRef.current.values, evalReq, this.state.evalInfo, this.state.evalExpanData, this.state.maxPeriod, this.state.travelSysOpts);
          });
        }
      };

      /**
       * @description 於保費試算前檢核停賣管控規則
       * @param values 表單值
       * @param traveloffRules 停賣規則
       */
      const validateTraveloffBeforeEval = async (values: ICalcFormValue, traveloffRules: TradeoffRule[]) => {
        // 若無規則，則視為「不檢核」停賣規則(即放行)
        if (traveloffRules.length === 0) {
          return {
            isPass: true,
            messages: [],
            tips: []
          };
        }
        // 以保單「開始時間」篩選符合時間範圍內的規則
        const policyStart = moment(`${moment(values.START_DATE).format('YYYY/MM/DD')} ${values.START_HOUR}:00:00`);
        // const policyEnd = moment(`${moment(values.END_DATE).format('YYYY/MM/DD')} ${values.START_HOUR}:00:00`);
        const overlayRules: TradeoffRule[] = [];
        traveloffRules.forEach(rule => {
          const ruleStart = moment(rule.OFF_START_TIME);
          const ruleEnd = moment(rule.OFF_END_TIME);
          // // 1. 保險起日落入規則區間
          // if (policyStart.isSameOrAfter(ruleStart) && policyStart.isSameOrBefore(ruleEnd)) {
          //   if (!overlayRules.find(it => it.SN === rule.SN)) {
          //     overlayRules.push(rule);
          //   }
          // }
          // // 2. 保險迄日落入規則區間
          // if (policyEnd.isSameOrAfter(ruleStart) && policyEnd.isSameOrBefore(ruleEnd)) {
          //   if (!overlayRules.find(it => it.SN === rule.SN)) {
          //     overlayRules.push(rule);
          //   }
          // }
          // // 若是同時滿足 1、2，則必定被加入佇列中，不用特別處理
          // // 保險期間「外包」停賣規則起訖日
          // if (policyStart.isSameOrBefore(ruleStart) && policyEnd.isSameOrAfter(ruleEnd)) {
          //   if (!overlayRules.find(it => it.SN === rule.SN)) {
          //     overlayRules.push(rule);
          //   }
          // }
          // 調整判斷邏輯: 僅判斷「保單開始時間」，提示條件: 規則起始時間 <= 保單起日 < 規則結束時間 (2025/04/09)
          if (policyStart.isSameOrAfter(ruleStart) && policyStart.isBefore(ruleEnd)) {
            if (!overlayRules.find(it => it.SN === rule.SN)) {
              overlayRules.push(rule);
            }
          }
        });
        // 僅處理停賣方案為「全部」(A) 的規則，「部份方案」的檢核權責在中台 F14-007
        const destinationId: string[] = [];
        this.state.tempTravels.forEach(it => {
          if (it && it.COUNTRY_ID && it.COUNTRY_NAME) {
            destinationId.push(it.COUNTRY_ID);
          }
        });
        const messages: RuleMessage[] = [];
        const tips: RuleMessage[] = [];
        let _isPass = true;
        overlayRules.forEach(rule => {
          if (rule.OFF_PLAN === TradeoffRange.All) {
            if (rule.OFF_COUNTRY === TradeoffRange.All) {
              const msgTemplate = commonService.getCodeMsg(this.props.UICode, CodeId.W082);
              // 全部地區
              _isPass = false;
              const _text = commonService.getRuleText(msgTemplate, rule.OFF_START_TIME, rule.OFF_END_TIME);
              messages.push({
                ruleSN: rule.SN,
                text: _text
              });
            } else {
              const msgTemplate = commonService.getCodeMsg(this.props.UICode, CodeId.W083);
              // 部分地區：比對規則與選擇地區是否有重疊
              const hasCountry = this.state.tempTravels.find(it => rule.OFF_COUNTRY_ID && it.COUNTRY_ID && rule.OFF_COUNTRY_ID.includes(it.COUNTRY_ID));
              if (hasCountry && rule.OFF_COUNTRY_ID) {
                _isPass = false;
                // 針對規則設定的國家轉換
                const ruleCountryIDs = rule.OFF_COUNTRY_ID.split(',');
                const ruleCountryNames: string[] = [];
                ruleCountryIDs.forEach(id => {
                  const find = this.state.travelWarnings.find(it => it.COUNTRY_ID === id);
                  if (find && find.COUNTRY_NAME) ruleCountryNames.push(find.COUNTRY_NAME);
                });
                const _text = commonService.getRuleText(msgTemplate, rule.OFF_START_TIME, rule.OFF_END_TIME, ruleCountryNames.join('、'));
                messages.push({
                  ruleSN: rule.SN,
                  text: _text
                });
              }
            }
          } else {
            // workaround: 前端追加「部份方案」(B)的規則，若時間範圍、地區符合，即顯示 (2025/07/28)
            if (rule.OFF_COUNTRY === TradeoffRange.All) {
              const msgTemplate = commonService.getCodeMsg(this.props.UICode, CodeId.W084);
              // 全部地區
              const _text = commonService.getRuleText(msgTemplate, rule.OFF_START_TIME, rule.OFF_END_TIME);
              tips.push({
                ruleSN: rule.SN,
                text: _text
              });
            } else {
              const msgTemplate = commonService.getCodeMsg(this.props.UICode, CodeId.W085);
              let fitRule = false;
              if (rule.OFF_COUNTRY_ID) {
                destinationId.forEach(it => {
                  if (rule.OFF_COUNTRY_ID && rule.OFF_COUNTRY_ID.includes(it)) {
                    fitRule = true;
                  }
                });
                if (fitRule) {
                  // 針對規則設定的國家轉換
                  const ruleCountryIDs = rule.OFF_COUNTRY_ID.split(',');
                  const ruleCountryNames: string[] = [];
                  ruleCountryIDs.forEach(cid => {
                    const find = this.state.travelWarnings.find(it => it.COUNTRY_ID === cid);
                    if (find && find.COUNTRY_NAME) ruleCountryNames.push(find.COUNTRY_NAME);
                  });
                  const _text = commonService.getRuleText(msgTemplate, rule.OFF_START_TIME, rule.OFF_END_TIME, ruleCountryNames.join('、'));
                  tips.push({
                    ruleSN: rule.SN,
                    text: _text
                  });
                }
              }
            }
          }
        });
        return {
          isPass: _isPass,
          messages,
          tips
        };
      };

      // #region 產生旅遊種類下拉選單

      let travelKindOtp: JSX.Element[];
      if (this.props.products && this.props.products.PRODUCT.length > 0) {
        travelKindOtp = _.map(this.props.products.PRODUCT, (prod: Product, index: number) => {
          return <option key={index} value={prod.PROD_ID}>{prod.PROD_NAME}</option>;
        });
      }

      // #endregion

      // #region 產生附加特定活動保險下拉選單

      let attachSpecOpt: JSX.Element[];
      if (this.state.attachSpecCheck || this.state.prodId === TravelPlanType.SPI) {
        const sysOptions = commonService.sortSysOpts(this.state.spiSysOpts);
        attachSpecOpt = _.map(sysOptions, (sysOption: SysOptionModel, index: number) => {
          return <option key={index} value={sysOption.PARAM_VALUE}>{sysOption.PARAM_TEXT}</option>;
        });
      }

      // #endregion

      // #region 產生投保對象人數下拉選單

      let insuredOver15PersonOpt = new Array(0);
      let insuredUnder15PersonOpt = new Array(0);

      for (let i = 0; i <= InsuredPersonMatch[this.state.insCountState as InsCount]; i += 1) {
        insuredOver15PersonOpt.push(<option key={i} value={i}>{`${i}人`}</option>);
        insuredUnder15PersonOpt.push(<option key={i} value={i}>{`${i}人`}</option>);
      }

      if (this.state.insCountState === InsCount.MORE && this.state.insSubjectState === InsureSubject.Self && this.state.prodId !== TravelPlanType.NTAG) {
        insuredOver15PersonOpt = insuredOver15PersonOpt.filter((_, index) => index <= 1);
        insuredUnder15PersonOpt = insuredUnder15PersonOpt.filter((_, index) => index >= 1 && index <= 10);
      }

      // #endregion

      // #region 產生投保對象(年齡)意外失能保額下拉選單

      let under15AmtOtp: JSX.Element[];
      let under15FuneralAmtOtp: JSX.Element[];
      let over15AmtOtp: JSX.Element[];
      if (this.state.prodId && this.state.amtOpt) {
        _.forEach(this.state.amtOpt.AMOUNTOPTION, (amtOpt: AmtOptContent) => {
          switch (amtOpt.UNDER15) {
            case AgeOptAge.OverFifteen:
              over15AmtOtp = _.map(amtOpt.OPTIONS, (opt: AmtOptContentChild, index: number) => {
                return <option key={index} value={opt.VALUE}>{opt.TEXT}</option>;
              });
              break;
            case AgeOptAge.UnderFifteen:
              under15AmtOtp = _.map(amtOpt.OPTIONS, (opt: AmtOptContentChild, index: number) => {
                return <option key={index} value={opt.VALUE}>{opt.TEXT}</option>;
              });
              break;
          }
        });
        // 投保對象15歲以下，要顯示喪葬費用選項。投保對象15歲以上，無喪葬費用選項
        under15FuneralAmtOtp = this.state.amtOpt.MFUNERALOPTION
          .find(opt => opt.UNDER15 === '1')
          ?.OPTIONS
          ?.map((opt, index) => <option key={index} value={opt.VALUE}>{opt.TEXT}</option>) ??
          [];
      }

      // #endregion

      // #region 建立保險人數

      let insSubjects: JSX.Element[];
      if (this.state.insSubjectSysOptsFiltered.length > 0) {
        insSubjects = _.map(this.state.insSubjectSysOptsFiltered, (sysOption: SysOptionModel, index: number) => {
          return <option key={index} value={sysOption.PARAM_VALUE}>{sysOption.PARAM_TEXT}</option>;
        });
      }

      // #endregion

      // #region 產生 旅遊/活動地點 下拉選單值、熱門國家

      let touristArea: any;
      let touristCountry: any;
      let hotCountryTags: JSX.Element;
      const prodId = this.formikRef.current?.values.PROD_ID;
      let isDomestic = prodId === TravelPlanType.Domestic || prodId === TravelPlanType.MPA || prodId === TravelPlanType.SPI || prodId === TravelPlanType.WPA;
      let isBroad = prodId === TravelPlanType.Abroad || prodId === TravelPlanType.NTAG;

      if (this.props.travelWarnings && this.props.travelWarnings.length > 0) {
        if (this.state.tempTravels && this.state.tempTravels.length > 0 && this.state.tempTravels[0].GEOAREA_ID) {
          isDomestic = this.state.tempTravels[0].GEOAREA_ID === GeoAreaId.Domestic;

          isBroad = this.state.tempTravels[0].GEOAREA_ID !== GeoAreaId.Domestic;
        }

        let travelWarnings = [...this.props.travelWarnings];
        // 為國內保險
        if (isDomestic) {
          travelWarnings = _.filter(travelWarnings,
            (travelWarning: TravelWarning) => travelWarning.GEOAREA_ID === GeoAreaId.Domestic);
        }

        // 為國外保險
        if (isBroad) {
          travelWarnings = _.filter(travelWarnings,
            (travelWarning: TravelWarning) => travelWarning.GEOAREA_ID !== GeoAreaId.Domestic);
          // 判斷是否為申根保險
          if (prodId === TravelPlanType.NTAG) {
            travelWarnings = _.filter(travelWarnings, (travelWarning: TravelWarning) => travelWarning.GEOAREA_ID === GeoAreaId.EU);
          }
        }

        touristArea = _.map(travelWarnings, (travelWarning: TravelWarning, index: number) => {
          return <option key={index} value={travelWarning.GEOAREA_ID}>{travelWarning.GEOAREA_NAME}</option>;
        });

        if (this.state.activeTouristArea) {
          const area = _.find(this.props.travelWarnings, (travelWarning: TravelWarning, index: number) => travelWarning.GEOAREA_ID === this.state.activeTouristArea);
          if (!area) return;

          touristCountry = _.map(area.COUNTRYS, (countrys: TravelCountryContent, index: number) => {
            // 若為申根國家，僅顯示申根註記為 1 的國家
            if (prodId === TravelPlanType.NTAG) {
              if (countrys.SCHENGEN === TravelSchengen.No) return;

              return <option key={index} value={countrys.COUNTRY_ID}>{countrys.COUNTRY_NAME}</option>;
            } else {
              return <option key={index} value={countrys.COUNTRY_ID}>{countrys.COUNTRY_NAME}</option>;
            }
          });
        }

        // 建立熱門國家選項
        if (this.state.travelWarnings.length > 0) {
          let hotCountrys: any;
          hotCountrys = _.filter(this.state.travelWarnings, (travel: TravelWarningExpandData) => travel.HOT_COUNTRY).sort((first: any, second: any) => first.HOT_COUNTRY - second.HOT_COUNTRY);
          // 已選取旅遊地點，且為國內，篩選熱門國家選項為國內的
          if (isDomestic) {
            hotCountrys = _.filter(this.state.travelWarnings, (travel: TravelWarningExpandData) => travel.HOT_COUNTRY && travel.GEOAREA_ID === GeoAreaId.Domestic)
              .sort((first: any, second: any) => first.HOT_COUNTRY - second.HOT_COUNTRY);
          }

          // 已選取旅遊地點，且為國外，篩選熱門國家選項不為國內的
          if (isBroad) {
            hotCountrys = _.filter(this.state.travelWarnings, (travel: TravelWarningExpandData) => travel.HOT_COUNTRY && travel.GEOAREA_ID !== GeoAreaId.Domestic)
              .sort((first: any, second: any) => first.HOT_COUNTRY - second.HOT_COUNTRY);
            // 為申根保險，僅顯示申根國家
            if (prodId === TravelPlanType.NTAG) {
              // hotCountrys = _.filter(hotCountrys, (country: TravelWarningExpandData) => country.SCHENGEN === TravelSchengen.Yes);
              // 申根保險不需「熱門選項」(2024/12/5)
              hotCountrys = [];
            }
          }

          if (hotCountrys.length > 0 && !isTravelBubble && prodId !== TravelPlanType.Domestic) {
            const child = _.map(hotCountrys, (hotCountry: TravelWarningExpandData, index: number) => {
              return (
                <Link
                  to="/"
                  key={index}
                  className="element__link"
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                    e.preventDefault();
                    // if (!this.state.isDeclared) {
                    this.handleSetTravelTag(hotCountry.COUNTRY_ID || '');
                    this.setState({ activeTouristArea: '' });
                    this.formikRef.current.setFieldValue('TOURIST_DESTINATION', '');
                    this.formikRef.current.setFieldValue('TOURIST_COUNTRY', '');
                    // }
                  }}
                >
                  {hotCountry.COUNTRY_NAME}
                </Link>
              );
            });
            hotCountryTags = (
              <div className="insurance-info__countrys">
                <span>熱門國家:</span>
                {child}
              </div>
            );
          }
        }
      }

      // #endregion

      // #region 建立 旅遊 tag 用

      let travelTags: JSX.Element[];
      if (this.state.tempTravels.length > 0) {
        travelTags = _.map(this.state.tempTravels, (travel: TravelWarningExpandData, index: number) => {
          return (
            <div className="element__tag" key={index}>
              <button type="button" className="element__tag-btn" onClick={() => this.handleRemoveTravelTag(travel.GEOAREA_ID as string, travel.COUNTRY_ID as string)} />
              <span>{travel.COUNTRY_NAME}</span>
            </div>
          );
        });
      };

      /**
      * @description 切換種類時如果為國內->國外或申根重置日期
      */
      const handleResetDate = (targetValue:string, originalValues: any, setFieldValue: any) => {
        const resetDate = () => {
          setFieldValue('START_DATE', '');
          setFieldValue('END_DATE', '');
          setFieldValue('INSURED_TIME', '');
          setFieldValue('START_HOUR', '');
          this.setState(prev => ({
            ...prev,
            insuredStartDate: '',
            insuredEndDate: ''
          }));
        };
        // 如果從國外或申根切換到國內重置日期
        if (targetValue === TravelPlanType.Domestic && (originalValues === TravelPlanType.NTAG || originalValues === TravelPlanType.Abroad)) {
          resetDate();
        }
        // 如果從國內切換到國外或申根重置日期
        if (originalValues === TravelPlanType.Domestic && (targetValue === TravelPlanType.NTAG || targetValue === TravelPlanType.Abroad)) {
          resetDate();
        }
      };

      /**
       * @description 設定保險日期起始日disable條件
       */
      const disableStartDate = (current: any, values: any): boolean => {
        if (!current) return false;
        const insuredEndDate = this.state.insuredEndDate || values.END_DATE;
        const maxPeriod = this.props.products.PRODUCT.find(product => product.PROD_ID === values.PROD_ID)?.MAX_PERIOD ?? 0;
        const startDaysLimit = this.state.travelSysOpts.find(sysOpt => sysOpt.PARAM_ID === 'START_DAYS_LIMIT')?.PARAM_VALUE ?? 0;
        const sysDate = moment.unix(this.state.sysTime);
        const nzDate = commonService.normalizeTime(current.format('YYYY-MM-DD'), this.state.sysTime);
        const blackoutDates = JSON.parse(this.state.blackoutSysOpts.find(sysOpt => sysOpt.PARAM_ID === 'I01')?.PARAM_VALUE ?? '[]') ?? [''];
        const isTemporaryDate = [current.format('YYYY-MM-DD')].some((target: string) => blackoutDates.includes(target));
        if (insuredEndDate) {
          const nzEDate = commonService.normalizeTime(moment(insuredEndDate).format('YYYY-MM-DD'), this.state.sysTime);
          if (nzEDate > sysDate.clone().add(startDaysLimit, 'day')) {
            return (nzDate < sysDate || nzDate < nzEDate.clone().subtract(maxPeriod, 'day')) || nzDate > sysDate.clone().add(startDaysLimit, 'day') || (this.state.prodId !== TravelPlanType.Domestic && isTemporaryDate);
          } else {
            return (nzDate < sysDate || nzDate < nzEDate.clone().subtract(maxPeriod, 'day')) || nzDate >= nzEDate || (this.state.prodId !== TravelPlanType.Domestic && isTemporaryDate);
          }
        }
        return nzDate < sysDate || nzDate > sysDate.clone().add(startDaysLimit, 'day') || (this.state.prodId !== TravelPlanType.Domestic && isTemporaryDate);
      };

      // #endregion

      // #region 保險期間選項

      const insuredTimeOptions:any = [];

      if (insuredTimeOptions.length === 0 && this.formikRef.current && this.formikRef.current.values.START_DATE && moment(this.formikRef.current.values.START_DATE).format('YYYYMMDD') >= moment.unix(this.state.sysTime).format('YYYYMMDD')) {
        const disabledTime = commonService.getDisableTime(this.formikRef.current.values.START_DATE, this.state.sysTime);
        for (let i = disabledTime.length; i < 24; i++) {
          insuredTimeOptions.push(
            {
              value: i < 10 ? '0' + i.toString() : i.toString(),
              label: i < 10 ? '0' + i.toString() + '時' : i.toString() + '時'
            }
          );
        };
      };

      // #endregion

      return (
        <>
          <div className="insure-process-calc">
            {/* 我要試算 Form */}
            <div className="premium-calc-form">
              <Formik
                innerRef={this.formikRef}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleFormSubmit}
                enableReinitialize
              >
                {({ values, errors, touched, setFieldValue, handleChange }) => (
                  <Form onChange={() => {
                    if (this.state.evalInfo && this.state.evalInfo.EVAL_RESULT.INS_TYPE_ID) {
                      setTimeout(() => {
                        this.setState(prevState => {
                          return {
                            ...prevState,
                            evalInfo: initEvalInfo,
                            evalExpanData: new Array(0)
                          };
                        });
                      });
                    }
                  }}
                  >
                    <div className="premium-calc-form__content">
                      <div className="element__form-table">
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className={'element__form-group' + (errors.PROD_ID && touched.PROD_ID ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">種類*</div>
                              <Field
                                as="select"
                                name="PROD_ID"
                                data-fieldname="PROD_ID"
                                tabIndex={1}
                                id="kind-select"
                                className="element__select"
                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                  handleChange(e);
                                  handleSetAttachSpec(e, setFieldValue);
                                  handleCheckProdId(e);
                                  handleFetchAmtOpt(e, setFieldValue);
                                  this.handleGetTravelAreaInfo(e.currentTarget.value, values.INS_COUNT);
                                  if (e.currentTarget.value === TravelPlanType.TBP || e.currentTarget.value === TravelPlanType.NTAG) {
                                    setFieldValue('UNDER15_COUNT', '');
                                  }
                                  handleResetDate(e.currentTarget.value, values.PROD_ID, setFieldValue);
                                  this.handleExplainModalData(e.currentTarget.value, values.INS_COUNT);
                                  this.handleSubjectOpts(e.currentTarget.value, values.INS_COUNT, moment(values.START_DATE), null, this.state.travelPeriod);
                                }}
                              >
                                <option value="">請選擇</option>
                                {travelKindOtp}
                              </Field>
                              <div className="element__error-message">
                                <ErrorMessage name="PROD_ID" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          {
                            showSpi && (this.state.prodId === TravelPlanType.Domestic || this.state.prodId === TravelPlanType.Abroad || this.state.prodId === TravelPlanType.NTAG) &&
                              (
                                <div className="element__form-table-td">
                                  <div className="element__form-group-content">
                                    <div className="spi-area">
                                      <div className="element__checkbox-group">
                                        <label htmlFor="attach-specific-checkbox">
                                          <div className="element__checkbox">
                                            <Field
                                              type="checkbox"
                                              name="SPI_ATTACHED"
                                              id="attach-specific-checkbox"
                                              disabled={this.state.attachSpecState}
                                              onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                handleChange(e);
                                                const val = e.currentTarget.checked;
                                                this.setState(prevState => {
                                                  return {
                                                    ...prevState,
                                                    attachSpecCheck: val
                                                  };
                                                });
                                                if (!e.currentTarget.checked) setFieldValue('SPI_TYPE', '');
                                              }}
                                            />
                                            <div className="element__checkbox-btn" />
                                          </div>
                                          <span className="spi-area spi-area__title">附加特定活動保險</span>
                                        </label>
                                      </div>
                                      <div className="spi-area spi-area__type">
                                        <Field
                                          as="select"
                                          name="SPI_TYPE"
                                          id="activity-category-select"
                                          className="element__select"
                                          disabled={(!this.state.attachSpecCheck && values.PROD_ID !== TravelPlanType.SPI)}
                                        >
                                          <option value="">請選擇活動類別</option>
                                          {attachSpecOpt}
                                        </Field>
                                        <div className="spi-area spi-area__errormsg">
                                          <ErrorMessage name="SPI_TYPE" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                          }
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className="element__form-group">
                              <div className="element__form-group-title" style={{ visibility: 'hidden' }}>自</div>
                              <div className="element__form-group-title">自</div>
                            </div>
                            <div className={'element__form-group' + (errors.START_DATE && touched.START_DATE ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">保險期間*</div>
                              <div className="element__form-group-content">
                                <DatePicker
                                  className="element__input"
                                  name="START_DATE"
                                  onFocus={async () => await this.getSysTime()}
                                  disabledDate={(current: any) => disableStartDate(current, values)}
                                  inputReadOnly
                                  data-fieldname="START_DATE"
                                  onChange={async (e: any) => {
                                    const startDate = e ? moment(e) : null;
                                    // 取得系統時間
                                    const serverTimeMs = await apiCommonService.fetchSysTime();
                                    const sysTime = Math.ceil(serverTimeMs / 1000);
                                    this.handleSubjectOpts(values.PROD_ID, values.INS_COUNT, e, sysTime, this.state.travelPeriod);
                                    if (startDate) {
                                      const nzDate = commonService.normalizeTime(startDate.format('YYYY-MM-DD'), this.state.sysTime);
                                      setFieldValue('START_DATE', nzDate);
                                      this.setState(prevState => {
                                        return {
                                          ...prevState,
                                          insuredStartDate: nzDate,
                                          evalInfo: initEvalInfo,
                                          evalExpanData: new Array(0)
                                        };
                                      });
                                    } else {
                                      setFieldValue('START_DATE', null);
                                      this.setState(prevState => {
                                        return {
                                          ...prevState,
                                          insuredStartDate: null,
                                          evalInfo: initEvalInfo,
                                          evalExpanData: new Array(0)
                                        };
                                      });
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            <div className={'element__form-group' + (errors.INSURED_TIME && touched.INSURED_TIME ? ' element__form-group--invalid' : '')}>
                              {/* 註解掉未使用節點 */}
                              {/* <div className="element__form-group-title" style={{ visibility: 'hidden' }}>保險起日時間*</div> */}
                              <div className="element__form-group-content">
                                {/* <TimePicker
                                  className="element__input"
                                  name="INSURED_TIME"
                                  data-fieldname="INSURED_TIME"
                                  tabIndex={3}
                                  inputReadOnly
                                  format="HH時"
                                  onSelect={(e: any) => {
                                    const tzTime = moment(e);
                                    if (!this.formikRef.current.values.INSURED_TIME) {
                                      // 說明：若尚無時間設定，則所選台灣時間會被 antd 再換算到當前時區的對應時間，故需還原回台灣時區
                                      const curTz = new Date().getTimezoneOffset() / -60;
                                      tzTime.add(curTz - 8, 'h');
                                    }
                                    setFieldValue('INSURED_TIME', tzTime);
                                    this.setState(prevState => {
                                      return {
                                        ...prevState,
                                        evalInfo: initEvalInfo,
                                        openTimer: false
                                      };
                                    });
                                  }}
                                  open={this.state.openTimer}
                                  onOpenChange={(val: any) => {
                                    this.setState(prevState => {
                                      return {
                                        ...prevState,
                                        openTimer: val
                                      };
                                    });
                                  }}
                                  onFocus={async () => await this.getSysTime()}
                                  disabledHours={() => commonService.getDisableTime(values.START_DATE, this.state.sysTime)}
                                  hideDisabledOptions
                                  showNow={false}
                                /> */}
                                <Select
                                  name="START_HOUR"
                                  options={insuredTimeOptions}
                                  className="element__input"
                                  data-fieldname="START_HOUR"
                                  tabIndex={3}
                                  onFocus={async () => await this.getSysTime()}
                                  onSelect={(e: any) => {
                                    setFieldValue('START_HOUR', e);
                                    setFieldValue('INSURED_TIME', moment(e, 'HH'));
                                    this.setState(prevState => {
                                      return {
                                        ...prevState,
                                        evalInfo: initEvalInfo,
                                        evalExpanData: new Array(0),
                                        openTimer: false
                                      };
                                    });
                                  }}
                                  open={this.state.openTimer}
                                  onDropdownVisibleChange={(val: any) => {
                                    this.setState(prevState => {
                                      return {
                                        ...prevState,
                                        openTimer: val
                                      };
                                    });
                                  }}
                                  suffixIcon={<ClockCircleOutlined />}
                                  placeholder="請選擇時間"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className="element__form-group">
                              <div className="element__form-group-title">至</div>
                            </div>
                            <div className={'element__form-group' + (errors.END_DATE && touched.END_DATE ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-content">
                                <DatePicker
                                  className="element__input"
                                  name="END_DATE"
                                  // defaultPickerValue={values.START_DATE ? moment(values.START_DATE, 'YYYY-MM-DD') : undefined}
                                  onFocus={async () => await this.getSysTime()}
                                  inputReadOnly
                                  disabledDate={(current: any) => {
                                    if (!current) return false;
                                    const insuredStartDate = this.state.insuredStartDate || values.START_DATE;
                                    const maxPeriod = this.props.products.PRODUCT.find(product => product.PROD_ID === values.PROD_ID)?.MAX_PERIOD ?? 0;
                                    const startDaysLimit = this.state.travelSysOpts.find(sysOpt => sysOpt.PARAM_ID === 'START_DAYS_LIMIT')?.PARAM_VALUE ?? 0;
                                    const sysDate = moment.unix(this.state.sysTime);
                                    const nzDate = commonService.normalizeTime(current.format('YYYY-MM-DD'), this.state.sysTime);
                                    if (insuredStartDate) {
                                      const nzSDate = commonService.normalizeTime(moment(insuredStartDate).format('YYYY-MM-DD'), this.state.sysTime);
                                      return nzDate < nzSDate.clone().add(1, 'day') || nzDate > nzSDate.clone().add(maxPeriod, 'day');
                                    }
                                    return nzDate < sysDate || nzDate > sysDate.clone().add(startDaysLimit, 'day');
                                  }}
                                  onOpenChange={(status) => {
                                    if (status && values.START_DATE && !values.END_DATE) {
                                      // 已是校準過的時間
                                      const endDate = moment(values.START_DATE, 'YYYY-MM-DD').add(6, 'days');
                                      setFieldValue('END_DATE', endDate);
                                      this.setState({ insuredEndDate: endDate });
                                    }
                                  }}
                                  onChange={(e: any) => {
                                    const endDate = e ? moment(e) : null;
                                    if (endDate) {
                                      const nzDate = commonService.normalizeTime(endDate.format('YYYY-MM-DD'), this.state.sysTime);
                                      setFieldValue('END_DATE', nzDate);
                                      this.setState(prevState => {
                                        return {
                                          ...prevState,
                                          insuredEndDate: nzDate,
                                          evalInfo: initEvalInfo,
                                          evalExpanData: new Array(0)
                                        };
                                      });
                                    } else {
                                      // 仍需清除結束時間，以解除原選取「開始日期」的可選範圍
                                      setFieldValue('END_DATE', null);
                                      this.setState(prevState => {
                                        return {
                                          ...prevState,
                                          insuredEndDate: null,
                                          evalInfo: initEvalInfo,
                                          evalExpanData: new Array(0)
                                        };
                                      });
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            <div className="element__form-group">
                              {/* <div className="element__form-group-title">保險迄日時間*</div> */}
                              <div className="element__form-group-content">
                                {/* <TimePicker
                                  className="element__input"
                                  name="INSURED_TIME"
                                  data-fieldname="INSURED_TIME"
                                  tabIndex={3}
                                  inputReadOnly
                                  format="HH時"
                                  disabled
                                /> */}
                                <Select
                                  name="START_HOUR"
                                  options={insuredTimeOptions}
                                  className="element__input"
                                  data-fieldname="START_HOUR"
                                  tabIndex={3}
                                  suffixIcon={<ClockCircleOutlined />}
                                  placeholder="請選擇時間"
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className="element__form-group">
                              <div>{handleShowPeriodMsg(values.INSURED_TIME)}</div>
                            </div>
                            {
                              (errors.START_DATE || errors.END_DATE || errors.INSURED_TIME) && (
                                <div className="element__error-message">
                                  <p>此為必填欄位</p>
                                </div>
                              )
                            }

                            {/* <span className="element__link" onClick={this.handlePreviewFillExample}>【說明】該如何幫自己及家人投保?</span> */}
                            <span className="element__link" onClick={this.handlePreviewFillExample}>【說明】該如何幫自己及家人投保?</span><br />
                            {/* 隱藏投保小幫手 */}
                            {/* <span className="element__link" onClick={this.handlePreviewInsureHelper}>【投保小幫手】</span><span className="mobile-qa">| &nbsp;{commonService.htmlParser(commonService.getCodeMsg(this.props.UICode, CodeId.U045))}</span><br /> */}
                            <span className="element__link" onClick={this.handlePreviewAbroad}>【一圖看懂海外救援】</span>

                            <p className="premium-calc-form__highlight-text">{commonService.htmlParser(commonService.getCodeMsg(this.props.UICode, CodeId.U022))}</p>
                          </div>
                        </div>
                        {/* <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className={'element__form-group' + ((errors.TOURIST_DESTINATION && touched.TOURIST_DESTINATION) || (errors.TOURIST_COUNTRY && touched.TOURIST_COUNTRY) ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">旅遊/活動地點</div>
                              <div className="element__form-group-content">
                                <Field
                                  as="select"
                                  name="TOURIST_DESTINATION"
                                  data-fieldname="TOURIST_DESTINATION"
                                  tabIndex={2}
                                  id="continent-select"
                                  className="element__select"
                                  // disabled={this.state.isDeclared || isTravelBubble}
                                  disabled={isTravelBubble}
                                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                    handleChange(e);
                                    this.setState({ activeTouristArea: e.currentTarget.value });
                                  }}
                                >
                                  <option value="">請選擇</option>
                                  {touristArea}
                                </Field>
                                <Field
                                  as="select"
                                  name="TOURIST_COUNTRY"
                                  data-fieldname="TOURIST_COUNTRY"
                                  tabIndex={3}
                                  id="country-select"
                                  className="element__select"
                                  // disabled={this.state.isDeclared || isTravelBubble}
                                  disabled={isTravelBubble}
                                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                    handleChange(e);
                                    this.handleSetTravelTag(e.currentTarget.value);
                                  }}
                                >
                                  <option value="">請選擇</option>
                                  {touristCountry}
                                </Field>
                                <div className="insurance-info__tags">
                                  {travelTags}
                                </div>
                                {hotCountryTags}
                              </div>
                              <div className="element__error-message">
                                {
                                  errors.TOURIST_DESTINATION
                                    ? <ErrorMessage name="TOURIST_DESTINATION" />
                                    : errors.TOURIST_COUNTRY
                                      ? <ErrorMessage name="TOURIST_COUNTRY" />
                                      : ''
                                }
                              </div>
                              {
                                // this.props.tempCalc?.planData?.PROD_ID === TravelPlanType.MPA
                                //   ? (
                                //     <Field
                                //       type="text"
                                //       className="element__input torist-mountain"
                                //       placeholder="玉山/雪山/馬博拉斯山…"
                                //       name="TOURIST_MOUNTAIN"
                                //       maxLength={200}
                                //       autoComplete="off"
                                //     />
                                //   )
                                //   : null
                              }
                            </div>
                          </div>
                        </div> */}
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className={'element__form-group' + (errors.TOURIST_SELECT && touched.TOURIST_SELECT ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">旅遊/活動地點</div>
                              <div className="element__form-group-content">
                                <FilterSelect
                                  isDomestic={isDomestic}
                                  isBroad={isBroad}
                                  prodId={prodId}
                                  maxCount={6}
                                  selected2={this.state.tempTravels ?? []}
                                  disabled={prodId === TravelPlanType.Domestic}
                                  onItemRemove={(groupId, itemId) => {
                                    this.handleRemoveTravelTag(groupId, itemId);
                                  }}
                                  onItemAdd={async (groupId, itemId) => {
                                    const tempTravels = _.cloneDeep(this.state.tempTravels);
                                    const travelInfo = _.find(this.state.travelWarnings, (travel: TravelWarningExpandData) => travel.COUNTRY_ID === itemId);
                                    if (travelInfo) {
                                      // 提示警示訊息
                                      this.handleShwoTravelMsg(travelInfo);

                                      // 判斷旅遊警示是否為橙色，是，紀錄選取時間
                                      let warnSelectTime;
                                      if (travelInfo.WARN_STATUS === WarnStatus.Orange) {
                                        warnSelectTime = await apiCommonService.fetchSysTime();
                                      };

                                      travelInfo.WARN_SELECT_TIME = warnSelectTime;
                                      tempTravels.push(travelInfo);
                                      if (tempTravels.length > 0) {
                                        this.formikRef.current.setFieldError('TOURIST_SELECT', '');
                                      }
                                      this.setState({
                                        tempTravels: [...tempTravels],
                                        evalInfo: initEvalInfo,
                                        evalExpanData: new Array(0)
                                      });
                                    }
                                  }}
                                >
                                  {hotCountryTags}
                                </FilterSelect>
                              </div>
                              <div className="element__error-message">
                                <ErrorMessage name="TOURIST_SELECT" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr" style={{ marginTop: '20px' }}>
                          <div className="element__form-table-td">
                            <div className="element__form-group">
                              <div className="element__form-group-title">保險人數*</div>
                              <div className="element__form-group-content">
                                {handleCreateInsCount(handleChange, setFieldValue, values)}
                              </div>
                              <div className="element__error-message">
                                <ErrorMessage name="INS_COUNT" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className={'element__form-group' + (errors.INSURED_SUBJECT && touched.INSURED_SUBJECT ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">保險對象*</div>
                              <div className="element__form-group-content">
                                <Field
                                  as="select"
                                  name="INSURED_SUBJECT"
                                  data-fieldname="INSURED_SUBJECT"
                                  tabIndex={4}
                                  id="insurance-object-select"
                                  className="element__select"
                                  disabled={insSubjects?.length === 1}
                                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                    const val = e.currentTarget.value;
                                    // handleShowLoginInfo(this.state.insCountState, e.currentTarget.value, setFieldValue);
                                    if (val && val === InsureSubject.Self && this.props.fetchFavoriteComplete && values.INS_COUNT === InsCount.One) {
                                      setFieldValue('UNDER15_COUNT', '0');
                                      setFieldValue('OVER15_COUNT', '1');
                                    }
                                    this.setState({ insSubjectState: val });
                                    handleChange('INSURED_SUBJECT')(e);
                                  }}
                                >
                                  {insSubjects?.length > 1 && <option value="">請選擇</option>}
                                  {insSubjects}
                                </Field>
                              </div>
                              <div className="element__error-message">
                                <ErrorMessage name="INSURED_SUBJECT" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className="element__form-group">
                              <div className="element__form-group-title">投保對象15歲以上人數</div>
                              <div className="element__form-group-content">
                                <Field
                                  as="select"
                                  name="OVER15_COUNT"
                                  id="above-15-years-old-select"
                                  className="element__select"
                                  onChange={this.handleOver15CountFieldChange}
                                  // disabled={values.INS_COUNT === InsCount.One}
                                >
                                  <option value="">請選擇</option>
                                  {insuredOver15PersonOpt}
                                </Field>
                              </div>
                            </div>
                            <div className="element__form-group">
                              <div className="element__form-group-title">意外身故及失能</div>
                              <div className="element__form-group-content">
                                <Field as="select" name="OVER15_AMOUNT" id="above-15-years-old-accident-select" className="element__select" disabled={values.OVER15_COUNT === '0' || !values.OVER15_COUNT}>
                                  {/* <option value="">請選擇</option> */}
                                  {over15AmtOtp}
                                </Field>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            {
                              values.INS_COUNT === InsCount.MORE &&
                              values.INSURED_SUBJECT === InsureSubject.All &&
                              +values.OVER15_AMOUNT >= 6000000 && (
                                <div>
                                  <p><mark>※國內旅遊或申根保險 : 限70歲以下投保;</mark></p>
                                  <p><mark>國外旅遊(非申根) : 70歲以上最高保額為 500 萬;</mark></p>
                                  <p><mark>多人投保時，15歲以上被保險人保額須相同，或請分開投保。</mark></p>
                                </div>
                              )
                            }
                          </div>
                        </div>
                        {/* {
                          !(this.props.fetchFavoriteComplete &&
                            values.INS_COUNT === InsCount.One &&
                            values.INSURED_SUBJECT === InsureSubject.Self) &&
                            values.PROD_ID !== TravelPlanType.TBP && ( */}
                        {values.PROD_ID !== TravelPlanType.NTAG &&
                          <div className="element__form-table-tr">
                            <div className="element__form-table-td w-73">
                              <div className="element__form-group">
                                <div className="element__form-group-title">投保對象未滿15歲人數</div>
                                <div className="element__form-group-content">
                                  <Field
                                    as="select"
                                    name="UNDER15_COUNT"
                                    id="under-15-years-old-select"
                                    className="element__select"
                                    onChange={this.handleUnder15CountFieldChange}
                                  >
                                    <option value="">請選擇</option>
                                    {insuredUnder15PersonOpt}
                                  </Field>
                                </div>
                              </div>
                              <div className="element__form-group">
                                <div className="element__form-group-title">意外失能 (15歲以下)</div>
                                <div className="element__form-group-content">
                                  <Field
                                    as="select"
                                    name="UNDER15_AMOUNT"
                                    id="under-15-years-old-accident-select"
                                    className="element__select"
                                    disabled={values.UNDER15_COUNT === '0' || !values.UNDER15_COUNT}
                                  >
                                    {/* <option value="">請選擇</option> */}
                                    {under15AmtOtp}
                                  </Field>
                                </div>
                              </div>
                              <div className="element__form-group">
                                <div className="element__form-group-title">喪葬費用 (15歲以下)</div>
                                <div className="element__form-group-content">
                                  <Field
                                    as="select"
                                    name="MFUNERAL"
                                    id="under-15-years-old-accident-select"
                                    className="element__select"
                                    disabled={values.UNDER15_COUNT === '0' || !values.UNDER15_COUNT}
                                  >
                                    {under15FuneralAmtOtp}
                                  </Field>
                                </div>
                              </div>
                            </div>
                          </div>}
                        <div className="element__form-table-tr">
                          <div className="element__form-table-td">
                            <div className={'element__form-group' + (errors.PROGRAM_ID ? ' element__form-group--invalid' : '')}>
                              <div className="element__form-group-title">活動代碼/推薦員編 <span>{commonService.htmlParser(commonService.getCodeMsg(this.props.UICode, CodeId.U044))}</span></div>
                              <div className="element__form-group-content">
                                <Field type="text" autoComplete="off" name="PROGRAM_ID" id="project-code-input" className="element__input" />
                              </div>
                              <div className="element__error-message">
                                <ErrorMessage name="PROGRAM_ID" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="premium-calc-form__controls">
                      <button type="button" className="element__button element__button--red" disabled={this.state.prodError} onClick={this.handleConfirm}>保費試算</button>
                    </div>
                    <FormikFocusError />
                  </Form>
                )}
              </Formik>
            </div>
            <div ref={this.calcResRef}>
              {/* 我要試算 List */}
              {calcResArea}
              {/* 我要試算 List Mobile */}
              {calcResMobile}
            </div>
          </div>
          {this.props.modal.loginModalState.visible && (
            <LoginModal
              title={this.state.loginModalTitle}
              onLoginDone={this.handleLoginModalnLoginDone}
              onClose={this.handleLoginModalClose}
            />
          )}
          {/* 如何填寫 (Modal) */}
          <ExplainModal data={this.state.explainModalData} tableTitle={this.state.explainModalTitle} />
          <InsureHelperModal />
          <AbroadModal />
          <ProductExplainModal />
          {this.formikRef.current && <ConfirmModal formValues={this.formikRef.current.values} tempTravels={this.state.tempTravels} onConfirm={() => this.formikRef.current.submitForm()} title="投保資料確認" />}
        </>
      );
    }
}

const mapStateToProps = (state: RootReducersState) => {
  return {
    fetchFavoriteComplete: state.myFavorite.fetchFavoriteComplete,
    modal: state.modal
  };
};

const mapDisatchToProps = (dispatch: Dispatch) => {
  return {
    setExplainModalVisible: (visible: boolean) => dispatch(setExplainModalVisibleAction(visible)),
    setInsureHelperModalVisible: (visible: boolean) => dispatch(setInsureHelperModalVisibleAction(visible)),
    setAbroadModalVisible: (visible: boolean) => dispatch(setAbroadModalVisibleAction(visible)),
    setLoginModalVisible: (visible: boolean) => dispatch(setLoginModalVisible(visible)),
    setProductExplainVisible: (visible: boolean) => dispatch(setProductExplainModalVisibleAction(visible)),
    setConfirmModalVisible: (visible: boolean) => dispatch(setConfirmModalVisibleAction(visible))
  };
};

export default connect(mapStateToProps, mapDisatchToProps)(withRouter(InsureProcessCalc));
